var map = {
  "./_deziiign/s-jurisprudence/routesList": [
    "35639",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "85500"
  ],
  "./_deziiign/lpudesign/styles": [
    "72095",
    9,
    "29364"
  ],
  "./_deziiign/adcrdafesnet/app": [
    "72893",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "68398"
  ],
  "./_deziiign/main/pages/moderView/index.ts": [
    "15597",
    9,
    "51382",
    "70494"
  ],
  "./_deziiign/books/core/components/grid": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/onlines/pages/readymag/english/styles.ts": [
    "45149",
    9,
    "1979",
    "13918",
    "63342"
  ],
  "./_deziiign/books/core/components/datePickerRange/DatePickerRange.tsx": [
    "30204",
    9,
    "13908",
    "39757"
  ],
  "./_deziiign/s-geography/routesList.tsx": [
    "10596",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97093"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCertificatesBlock.tsx": [
    "2850",
    9
  ],
  "./_deziiign/books/pages/tag/index": [
    "17800",
    9,
    "13908",
    "21655",
    "21565",
    "59761"
  ],
  "./_deziiign/onlines/pages/readymag/library/styles": [
    "33756",
    9,
    "94253"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/styles.ts": [
    "86409",
    9,
    "94930"
  ],
  "./_deziiign/sportmediiia/app": [
    "37223",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "4076"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout.tsx": [
    "99082",
    9
  ],
  "./_deziiign/main/pages/tagAdmin": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_deziiign/s-urban-development/routesList.tsx": [
    "14622",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "14419"
  ],
  "./_deziiign/damuseum/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "62023",
    9,
    "35499",
    "96716"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/TagsTypeSwitcher.tsx": [
    "51152",
    9
  ],
  "./_geograffee/dafes/pages/CountryShowcase": [
    "62779",
    9,
    "15969",
    "35974",
    "24092"
  ],
  "./_deziiign/books/pages/BookView/components/BookHeader": [
    "6371",
    9,
    "95360"
  ],
  "./_deziiign/booksmediiia/routesList": [
    "69210",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44807"
  ],
  "./_deziiign/continuumsite/img/image_1440.png": [
    "58626",
    1,
    "3167"
  ],
  "./_deziiign/hsecreative/styles": [
    "41431",
    9,
    "7036"
  ],
  "./_deziiign/historymediiia/app": [
    "70761",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "49970"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagAdd.tsx": [
    "34484",
    9,
    "3157"
  ],
  "./_deziiign/books/pages/sections/ps-chapters.tsx": [
    "10434",
    9
  ],
  "./_deziiign/s-mathematics/app": [
    "63417",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "3138"
  ],
  "./_competition/pages/PreRegistrationResult": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/hsehh/app.tsx": [
    "3651",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "94624"
  ],
  "./_deziiign/books/core/components/template/book-container-layout.styles": [
    "5703",
    9,
    "1877"
  ],
  "./_deziiign/onlines/routesList": [
    "68354",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6047"
  ],
  "./_deziiign/main/pages/moderHseView/ProjectTilesMapDeziiign.tsx": [
    "61848",
    9,
    "45825"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/styles.ts": [
    "93487",
    9,
    "77316"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationTwo.svg": [
    "53123",
    1,
    "28832"
  ],
  "./_deziiign/books/core/components/tooltips/BookTooltip.tsx": [
    "67816",
    9
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout.css": [
    "86691",
    9,
    "63008"
  ],
  "./_geograffee/dafes/pages/CountryShowcase.tsx": [
    "62779",
    9,
    "15969",
    "35974",
    "24092"
  ],
  "./_deziiign/hsestart/styles.tsx": [
    "69730",
    9,
    "59551"
  ],
  "./_competition/pages/AllCompetitionsPage/competitionTagsCloud.tsx": [
    "40443",
    9
  ],
  "./_deziiign/monalisatravels/routesList.tsx": [
    "58745",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "93410"
  ],
  "./_deziiign/historymediiia/routesList": [
    "93384",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "24881"
  ],
  "./_competition/components/CompetitionTellingStoriesPreview.tsx": [
    "29619",
    9,
    "13456"
  ],
  "./_deziiign/continuumsite/img/image_320.png": [
    "76496",
    1,
    "92841"
  ],
  "./_deziiign/main/pages/projectDeziign/styles.tsx": [
    "16478",
    9,
    "13043"
  ],
  "./_deziiign/greenaward/components/IndexTitle": [
    "69371",
    9,
    "88360"
  ],
  "./_deziiign/books/pages/BookEdit/sections/ProtectSection.tsx": [
    "80194",
    9
  ],
  "./_deziiign/s-public-administration/routesList.tsx": [
    "96916",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "51125"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useShowcaseTexts": [
    "61644",
    9
  ],
  "./_deziiign/ageytomesh/routesList": [
    "92044",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "67741"
  ],
  "./_deziiign/storiesmediiia/routesList.tsx": [
    "88515",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "20800"
  ],
  "./_deziiign/damuseum/app": [
    "70666",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "12439"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/flagtop.svg": [
    "57053",
    1,
    "56942"
  ],
  "./_deziiign/fashion/app": [
    "979",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71856"
  ],
  "./_deziiign/s-political-science/routesList.tsx": [
    "7938",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "90783"
  ],
  "./_deziiign/s-cinema/routesList": [
    "18301",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "5262"
  ],
  "./_competition/pages/AllCompetitionsPage/AllCompetitionsPage.tsx": [
    "21593",
    9
  ],
  "./_competition/pages/CompetitionResultsPage/index": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/NumberContentEditField": [
    "34897",
    9,
    "40266"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/OpenDay": [
    "69568",
    9,
    "6153",
    "1979",
    "64171",
    "93081"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionAutomaticPage.tsx": [
    "8078",
    9,
    "53283"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBarLayout": [
    "80714",
    9,
    "51735"
  ],
  "./_deziiign/designmediiia/app": [
    "72483",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "25760"
  ],
  "./_deziiign/books/core/book-delegate.ts": [
    "88325",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/": [
    "60929",
    9,
    "14618"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardTools": [
    "19117",
    9
  ],
  "./_deziiign/lab/routesList.tsx": [
    "59821",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "68990"
  ],
  "./_deziiign/online/styles": [
    "10509",
    9,
    "50718"
  ],
  "./_deziiign/main/pages/projectDeziign/projectDeziign": [
    "68537",
    9,
    "19955",
    "61186"
  ],
  "./_deziiign/aimediiia/routesList.tsx": [
    "83870",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "42291"
  ],
  "./_competition/pages/CompetitionResultsPage": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/kiiids/components/IndexTitle": [
    "58818",
    9,
    "53023"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionWinnerName.tsx": [
    "20936",
    9
  ],
  "./_deziiign/books/core/components/shareButton/index.ts": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/TLandContentEditField.tsx": [
    "96241",
    9,
    "80298"
  ],
  "./_deziiign/main/pages/moderHseView/index.ts": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/kiiids/routesList": [
    "85885",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "81038"
  ],
  "./_deziiign/onlines/pages/readymag/library/styles.ts": [
    "33756",
    9,
    "94253"
  ],
  "./_deziiign/school/routesList": [
    "262",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "87723"
  ],
  "./_deziiign/cinemediiia/app": [
    "27588",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50533"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveJuriesPage": [
    "22570",
    9,
    "83863"
  ],
  "./_deziiign/books/core/components/tooltips/": [
    "40356",
    9
  ],
  "./_deziiign/hsedesign/pages/StatisticsPage/StatisticsPage": [
    "32042",
    9,
    "13908",
    "26324",
    "10039"
  ],
  "./_deziiign/s-history/routesList.tsx": [
    "74294",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "58971"
  ],
  "./_deziiign/s-oriental/routesList.tsx": [
    "27850",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "9367"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookImageContainer.tsx": [
    "29312",
    9
  ],
  "./_deziiign/greenaward/utils": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/books/core/hook/api/useBookList.ts": [
    "72617",
    9,
    "96850"
  ],
  "./_deziiign/s-international-relations/routesList.tsx": [
    "48390",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "99627"
  ],
  "./_deziiign/onlines/routesList.tsx": [
    "68354",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6047"
  ],
  "./_deziiign/onlines/pages/readymag/video/VideoPage.tsx": [
    "48580",
    9,
    "1979",
    "13918",
    "63342",
    "74917"
  ],
  "./_deziiign/hsecreative/styles.tsx": [
    "41431",
    9,
    "7036"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/reducer/reducer": [
    "68649",
    9,
    "41906"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/blocks.svg": [
    "75650",
    1,
    "84127"
  ],
  "./_deziiign/books/pages/BookListView/BookListViewInner": [
    "8700",
    9,
    "13908",
    "21655",
    "21565",
    "5357"
  ],
  "./_deziiign/s-philosophy/routesList": [
    "89821",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "8782"
  ],
  "./_deziiign/books/pages/sections/assets/link.svg": [
    "12118",
    1,
    "187"
  ],
  "./_deziiign/books/pages/tag": [
    "17800",
    9,
    "13908",
    "21655",
    "21565",
    "59761"
  ],
  "./_deziiign/main/pages/eduTagAdmin/index.ts": [
    "25672",
    9,
    "27769",
    "32049"
  ],
  "./_deziiign/automediiia/routesList.tsx": [
    "83561",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54130"
  ],
  "./_deziiign/main/styles": [
    "94163",
    9,
    "28592"
  ],
  "./_deziiign/namesmediiia/app": [
    "47185",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "55402"
  ],
  "./_deziiign/artmediiia/app": [
    "43916",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "6749"
  ],
  "./_deziiign/automediiia/routesList": [
    "83561",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54130"
  ],
  "./_deziiign/s-arthistory/routesList.tsx": [
    "7121",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "87306"
  ],
  "./_deziiign/books/pages/BookChapterCreate/index": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/photomediiia/routesList": [
    "81564",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "41901"
  ],
  "./_geograffee/academy/app": [
    "47617",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5370"
  ],
  "./_deziiign/books/core/components/controllers/BooksButchController.tsx": [
    "90929",
    9,
    "68778"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanContentEditField": [
    "38958",
    9,
    "43907"
  ],
  "./_competition/pages/ShortListPage/assets/LaurelWreathRight.svg": [
    "31052",
    1,
    "34813"
  ],
  "./_deziiign/books/core/components/shareButton/": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/creativemediiia/app": [
    "38719",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86621"
  ],
  "./_deziiign/s-economy/routesList.tsx": [
    "59950",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "8771"
  ],
  "./_deziiign/onlines/pages/readymag/kz/ReadymagPageKZ.tsx": [
    "45660",
    9,
    "1979",
    "13918",
    "42722",
    "98042",
    "32301"
  ],
  "./_deziiign/books/pages/BookListView/BookListViewInner.tsx": [
    "8700",
    9,
    "13908",
    "21655",
    "21565",
    "5357"
  ],
  "./_deziiign/urbanmediiia/app": [
    "22093",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5214"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/wib1.jpg": [
    "20821",
    1,
    "91606"
  ],
  "./_deziiign/books/core/hook/api/useBook": [
    "97393",
    9,
    "75882"
  ],
  "./_deziiign/superpuper/styles.tsx": [
    "45757",
    9,
    "16398"
  ],
  "./_competition/components/CompetitionFormStart": [
    "53915",
    9,
    "80328"
  ],
  "./_competition/components/style": [
    "10301",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateBriefCompetition.tsx": [
    "94880",
    9,
    "17433"
  ],
  "./_deziiign/main/pages/tagAdmin/index.ts": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_deziiign/brnd/routesList": [
    "59684",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21733"
  ],
  "./_deziiign/kiiids/app": [
    "43814",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5227"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/index": [
    "67884",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "11325"
  ],
  "./_deziiign/lpudesign/routesList": [
    "56163",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "42368"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/index": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/hsedesign/styles": [
    "91408",
    9,
    "49545"
  ],
  "./_deziiign/hsespace/components/IndexTitle.tsx": [
    "47749",
    9,
    "79686"
  ],
  "./_deziiign/books/pages/BookEdit/sections/styles": [
    "14954",
    9
  ],
  "./_deziiign/books/pages/BookView/components/MainBookTitle": [
    "53341",
    9
  ],
  "./_deziiign/s-cinema/routesList.tsx": [
    "18301",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "5262"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext": [
    "4817",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "49674"
  ],
  "./_deziiign/automediiia/app": [
    "38106",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "99687"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/CombatEntitiesContentEditField": [
    "40683",
    9,
    "38776"
  ],
  "./_deziiign/cinemediiia/routesList.tsx": [
    "91311",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "81188"
  ],
  "./_deziiign/hsedesign/utils/index.ts": [
    "46106",
    9
  ],
  "./_deziiign/kiiids/pages/EmployeesModerContext/EmployeesModerContext": [
    "16179",
    9,
    "35499",
    "1680"
  ],
  "./_deziiign/books/pages/BookChapterCreate/": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/books/pages/sections/ps-chapters": [
    "10434",
    9
  ],
  "./_deziiign/main/routesList": [
    "67087",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "47108"
  ],
  "./_deziiign/onlines/OnlinesMetaTags": [
    "32482",
    9,
    "42143"
  ],
  "./_geograffee/hsealumni/app": [
    "78689",
    9,
    "83762",
    "50323",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "97775",
    "92287",
    "71237",
    "9452",
    "66673",
    "35499",
    "59037",
    "59017",
    "60204",
    "73645",
    "27354"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCardList": [
    "33014",
    9
  ],
  "./_deziiign/main/pages/projectDeziign": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/search.svg": [
    "93686",
    1,
    "51163"
  ],
  "./_deziiign/continuumsite/routesList.tsx": [
    "97765",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6886"
  ],
  "./_deziiign/iqmedia/routesList": [
    "70364",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "96525"
  ],
  "./_deziiign/photomediiia/routesList.tsx": [
    "81564",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "41901"
  ],
  "./_deziiign/s-oriental/routesList": [
    "27850",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "9367"
  ],
  "./_deziiign/s-biology/routesList.tsx": [
    "28257",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "73402"
  ],
  "./_deziiign/onlines/styles.tsx": [
    "50450",
    9,
    "73359"
  ],
  "./_deziiign/books/app": [
    "52905",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64585"
  ],
  "./_deziiign/musicmediiia/routesList.tsx": [
    "17469",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23406"
  ],
  "./_deziiign/onlines/pages/readymag/InitPage.tsx": [
    "82021",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "98042",
    "32301",
    "67269",
    "53414"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/styles": [
    "18626",
    9,
    "59871"
  ],
  "./_deziiign/cgrave/app": [
    "48621",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "63934"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Categories": [
    "93506",
    9
  ],
  "./_competition/components/SendProjectButton.tsx": [
    "26709",
    9
  ],
  "./_deziiign/s-history/app": [
    "25571",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83552"
  ],
  "./_deziiign/books/pages/BookEdit/styles": [
    "5171",
    9
  ],
  "./_deziiign/historymediiia/app.tsx": [
    "70761",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "49970"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/NumberContentEditField.tsx": [
    "34897",
    9,
    "40266"
  ],
  "./_deziiign/books/pages/BookEdit": [
    "25525",
    9,
    "44086"
  ],
  "./_deziiign/onlines/pages/readymag/english/ReadymagPage": [
    "43812",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "67269"
  ],
  "./_deziiign/books/pages/BookListView/": [
    "76584",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/pro/app": [
    "31834",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "43559"
  ],
  "./_deziiign/s-philosophy/app": [
    "9222",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50155"
  ],
  "./_deziiign/s-psychology/routesList": [
    "81139",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "25680"
  ],
  "./_deziiign/s-public-administration/app.tsx": [
    "21533",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "39662"
  ],
  "./_deziiign/books/pages/BookListView/BookListView": [
    "85406",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "96979"
  ],
  "./_competition/pages/JuryPage/index.ts": [
    "5122",
    9,
    "91967"
  ],
  "./_deziiign/galllleryart/routesList.tsx": [
    "43137",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "93914"
  ],
  "./_deziiign/hsecolors/app": [
    "19735",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "43452"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/ButtonEditField.tsx": [
    "95331",
    9,
    "46560"
  ],
  "./_deziiign/ageytomesh/app": [
    "61045",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "24822"
  ],
  "./_deziiign/booksmediiia/app.tsx": [
    "25247",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71668"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext/EmployeesContext.tsx": [
    "32497",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "32522"
  ],
  "./_competition/pages/JuryPage/CompetitionJuryPage": [
    "14449",
    9
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookChaptersEdit.tsx": [
    "58466",
    9
  ],
  "./_deziiign/books/core/components/tooltips/BookTooltip": [
    "67816",
    9
  ],
  "./_deziiign/awards/components/IndexTitle": [
    "81233",
    9,
    "96362"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/index.ts": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/lmshse/routesList": [
    "89406",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21267"
  ],
  "./_deziiign/dvadesign/routesList": [
    "13069",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "53918"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveNomineesPage": [
    "69662",
    9,
    "65235"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/MobileGlow.svg": [
    "27318",
    1,
    "74203"
  ],
  "./_deziiign/s-hsetto/routesList": [
    "54479",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "25668"
  ],
  "./_deziiign/damuseum/app.tsx": [
    "70666",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "12439"
  ],
  "./_deziiign/hsestart/routesList": [
    "94962",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "63279"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateBriefCompetition": [
    "94880",
    9,
    "17433"
  ],
  "./_deziiign/adcrdafesnet/const/CGRaveCompetitions.ts": [
    "68",
    9,
    "36069"
  ],
  "./_deziiign/artmediiia/routesList.tsx": [
    "6743",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "88156"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext/index.tsx": [
    "4817",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "49674"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/index": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagAdd": [
    "34484",
    9,
    "3157"
  ],
  "./_deziiign/s-pro/app.tsx": [
    "45622",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "18651"
  ],
  "./_deziiign/damuseum/pages/roleAdmin/RoleAdminPage": [
    "16914",
    9,
    "99567"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/searchresults": [
    "77349",
    9,
    "96678"
  ],
  "./_deziiign/kiiids/styles": [
    "19025",
    9,
    "99402"
  ],
  "./_deziiign/hsedesign/pages/roleAdmin/RoleAdminPage.tsx": [
    "2925",
    9,
    "99358"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/styles.ts": [
    "18476",
    9
  ],
  "./_deziiign/prohse/app": [
    "9256",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23313"
  ],
  "./_deziiign/cgrave/const/CGRaveCompetitions": [
    "97044",
    9,
    "15765"
  ],
  "./_deziiign/hseanimation/styles": [
    "37256",
    9,
    "38641"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArray2ContentEditField": [
    "81290",
    9,
    "55863"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustratonFour.svg": [
    "2724",
    1,
    "96069"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/photomediiia/app.tsx": [
    "6213",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5478"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListWinnerProjectsEdit": [
    "20260",
    9
  ],
  "./_deziiign/galllleryart/styles.ts": [
    "78199",
    9,
    "52700"
  ],
  "./_deziiign/books/core/components/designerSearch/DesignerSearch.tsx": [
    "10268",
    9,
    "21655",
    "42029"
  ],
  "./_deziiign/aimediiia/app.tsx": [
    "49867",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31576"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCards": [
    "70067",
    9
  ],
  "./_deziiign/profmediiia/app.tsx": [
    "18186",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "51031"
  ],
  "./_deziiign/school/pages/init.tsx": [
    "74957",
    9,
    "48382"
  ],
  "./_geograffee/__COMMON__/commonRoutes.tsx": [
    "68540",
    9,
    "13908",
    "24092",
    "21655",
    "35499",
    "22056",
    "21565",
    "40106",
    "5357",
    "59017",
    "23312",
    "52621"
  ],
  "./_geograffee/dafes/routesList.tsx": [
    "58305",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "43290"
  ],
  "./_competition/pages/JuryPage/index": [
    "5122",
    9,
    "91967"
  ],
  "./_deziiign/designmediiia/app.tsx": [
    "72483",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "25760"
  ],
  "./_deziiign/mediiia/routesList.tsx": [
    "24864",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "45497"
  ],
  "./_deziiign/books/pages/sections/ps-image.tsx": [
    "9421",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-title.tsx": [
    "35075",
    9,
    "95008"
  ],
  "./_deziiign/hsecreativehub/routesList.tsx": [
    "71242",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "57303"
  ],
  "./_competition/pages/CreateCompetitionPage/index.tsx": [
    "40565",
    9,
    "23126"
  ],
  "./_deziiign/books/pages/BookEdit/BookEdit.tsx": [
    "72536",
    9
  ],
  "./_deziiign/main/pages/moderView/ProjectTilesMapDeziiign": [
    "16148",
    9,
    "44821"
  ],
  "./_deziiign/conceptmediiia/routesList": [
    "83700",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "62165"
  ],
  "./_competition/pages/SeasonEdit/SeasonEditPage": [
    "94292",
    9,
    "78037"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-bottom.tsx": [
    "84958",
    9,
    "19955"
  ],
  "./_deziiign/s-media/routesList.tsx": [
    "88674",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "89023"
  ],
  "./_deziiign/onlines/pages/readymag/images/bg2Readymag.jpg": [
    "54970",
    1,
    "32487"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanContentEditField.tsx": [
    "38958",
    9,
    "43907"
  ],
  "./_deziiign/school/utils/": [
    "89716",
    9,
    "99509"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagEdit": [
    "441",
    9,
    "70530"
  ],
  "./_deziiign/awards/pages/EmployeesContext/EmployeesContext": [
    "59929",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "56043"
  ],
  "./_competition/pages/ProjectsPage/": [
    "31708",
    9,
    "99309"
  ],
  "./_deziiign/main/pages/projectDeziign/index.tsx": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_geograffee/__COMMON__/commonRoutes": [
    "68540",
    9,
    "13908",
    "24092",
    "21655",
    "35499",
    "22056",
    "21565",
    "40106",
    "5357",
    "59017",
    "23312",
    "52621"
  ],
  "./_competition/pages/AllCompetitionsPage/styled": [
    "70740",
    9
  ],
  "./_competition/pages/JuryPage/CompetitionJuryPage.tsx": [
    "14449",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationFive.svg": [
    "66863",
    1,
    "13892"
  ],
  "./_deziiign/cgrave/styles.ts": [
    "1380",
    9,
    "5093"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCards.tsx": [
    "70067",
    9
  ],
  "./_deziiign/adcrdafesnet/styles.ts": [
    "14100",
    9,
    "25653"
  ],
  "./_deziiign/kiiids/utils/index": [
    "25179",
    9,
    "14824"
  ],
  "./_deziiign/kiiids/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "16179",
    9,
    "35499",
    "1680"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/resultitem.tsx": [
    "1746",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/components/ProjectImage.tsx": [
    "77159",
    9,
    "6636"
  ],
  "./_deziiign/s-hsetto/routesList.tsx": [
    "54479",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "25668"
  ],
  "./_deziiign/onlines/styles": [
    "50450",
    9,
    "73359"
  ],
  "./_deziiign/cgrave/pages/CgRaveJuriesPage": [
    "55002",
    9,
    "31591"
  ],
  "./_deziiign/damuseum/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "41914",
    9,
    "64647"
  ],
  "./_deziiign/hsecolors/routesList.tsx": [
    "54706",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "40751"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/components/CompetitionModalTabs": [
    "79982",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/eligibility.svg": [
    "41699",
    1,
    "65120"
  ],
  "./_deziiign/s-fashion/routesList": [
    "7386",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "80679"
  ],
  "./_deziiign/automediiia/app.tsx": [
    "38106",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "99687"
  ],
  "./_competition/pages/AllCompetitionsPage/sections/section-cgrave.tsx": [
    "10954",
    9,
    "2967"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout": [
    "99082",
    9
  ],
  "./_competition/pages/CompetitionTable": [
    "69432",
    9,
    "22056",
    "38708",
    "91137"
  ],
  "./_deziiign/books/pages/BookChapterCreate/BookChapterCreate.tsx": [
    "52636",
    9,
    "85357"
  ],
  "./_deziiign/hsecreativehub/app": [
    "44527",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "95620"
  ],
  "./_deziiign/awards/utils/index.ts": [
    "97022",
    9,
    "7539"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/ButtonEditField": [
    "95331",
    9,
    "46560"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringContentEditField": [
    "32449",
    9,
    "50042"
  ],
  "./_deziiign/books/pages/BookView/components/BookTools": [
    "67079",
    9,
    "2325"
  ],
  "./_deziiign/continuumsite/styles.ts": [
    "5915",
    9,
    "9064"
  ],
  "./_deziiign/kiiids/utils": [
    "25179",
    9,
    "14824"
  ],
  "./_deziiign/lmshse/styles": [
    "98454",
    9,
    "4731"
  ],
  "./_deziiign/s-management/routesList": [
    "86269",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35054"
  ],
  "./_deziiign/main/pages/moderView/moderView": [
    "29397",
    9,
    "51382"
  ],
  "./_deziiign/storiesmediiia/routesList": [
    "88515",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "20800"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionCard": [
    "76742",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionAutomaticPage": [
    "8078",
    9,
    "53283"
  ],
  "./_deziiign/game/routesList": [
    "71368",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "75345"
  ],
  "./_deziiign/books/core/components/shareButton/index": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/books/core/components/designerSearch/designerSearchAuth": [
    "3978",
    9,
    "21655"
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/competitionUtils": [
    "22125",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/question.svg": [
    "39708",
    1,
    "19053"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/plus.svg": [
    "13427",
    1,
    "58928"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/whatsapp.svg": [
    "12962",
    1,
    "33567"
  ],
  "./_deziiign/books/core/components/helper/bookEvents": [
    "97590",
    9,
    "73051"
  ],
  "./_deziiign/main/pages/moderView/index": [
    "15597",
    9,
    "51382",
    "70494"
  ],
  "./_deziiign/booksgallllery/ExtraPage": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/main/pages/projectDeziign/index": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_competition/helpers/getDaysToFinish.ts": [
    "20572",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useCompetitionsTabs.tsx": [
    "70789",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/hand.png": [
    "45275",
    1,
    "66472"
  ],
  "./_deziiign/lmshse/styles.tsx": [
    "98454",
    9,
    "4731"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionGrid.tsx": [
    "1268",
    9
  ],
  "./_deziiign/hseanimation/styles.tsx": [
    "37256",
    9,
    "38641"
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/competitionUtils.ts": [
    "22125",
    9
  ],
  "./_deziiign/hsespacefilm/app.tsx": [
    "32499",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "38256"
  ],
  "./_deziiign/superpuper/styles": [
    "45757",
    9,
    "16398"
  ],
  "./_deziiign/kiiids/app.tsx": [
    "43814",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5227"
  ],
  "./_deziiign/greenaward/utils/index": [
    "96912",
    9,
    "94249"
  ],
  "./_geograffee/academy/app.tsx": [
    "47617",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5370"
  ],
  "./_deziiign/main/pages/admin/AdminPage": [
    "63176",
    9,
    "79665"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookPlusIcon.tsx": [
    "37305",
    9
  ],
  "./_deziiign/books/core/components/datePickerRange/DatePickerRange": [
    "30204",
    9,
    "13908",
    "39757"
  ],
  "./_deziiign/foodmediiia/routesList.tsx": [
    "62124",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "53245"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/wib2.jpg": [
    "69834",
    1,
    "86007"
  ],
  "./_deziiign/s-cinema/app": [
    "64646",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "363"
  ],
  "./_deziiign/s-arthistory/app.tsx": [
    "56821",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "28927"
  ],
  "./_deziiign/s-geography/app": [
    "84909",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "12670"
  ],
  "./_deziiign/transfermediiia/routesList": [
    "24253",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "88494"
  ],
  "./_deziiign/pro/routesList": [
    "16598",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "46706"
  ],
  "./_deziiign/school/utils/index.ts": [
    "89716",
    9,
    "99509"
  ],
  "./_competition/pages/AllCompetitionsPage/index.tsx": [
    "60929",
    9,
    "14618"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/components/Layout": [
    "56925",
    9
  ],
  "./_deziiign/adcrdafesnet/routesList": [
    "84852",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "39797"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionPage": [
    "18314",
    9
  ],
  "./_competition/components/CompetitionTellingStoriesPreview": [
    "29619",
    9,
    "13456"
  ],
  "./_deziiign/adcrdafesnet/styles": [
    "14100",
    9,
    "25653"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBar": [
    "89260",
    9,
    "13908",
    "21655",
    "21565"
  ],
  "./_deziiign/monalisatravels/app.tsx": [
    "23293",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "77655"
  ],
  "./_deziiign/s-physics/routesList": [
    "36487",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "39212"
  ],
  "./_deziiign/transfermediiia/routesList.tsx": [
    "24253",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "88494"
  ],
  "./_competition/components/TellingStoriesSuccess": [
    "43479",
    9,
    "10684"
  ],
  "./_deziiign/onlines/pages/readymag/english/styles": [
    "45149",
    9,
    "1979",
    "13918",
    "63342"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/LibBrandingPage.tsx": [
    "14885",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "58566"
  ],
  "./_deziiign/main/pages/moderHseView/": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/cinemediiia/routesList": [
    "91311",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "81188"
  ],
  "./_deziiign/hsespace/app": [
    "46345",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "22386"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/searchresults.tsx": [
    "77349",
    9,
    "96678"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookChaptersEdit": [
    "58466",
    9
  ],
  "./_deziiign/awards/routesList.tsx": [
    "80164",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "84709"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ai.svg": [
    "94285",
    1,
    "76254"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/styles": [
    "73222",
    9
  ],
  "./_deziiign/damuseum/routesList.tsx": [
    "99737",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35074"
  ],
  "./_deziiign/hsecolors/routesList": [
    "54706",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "40751"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/index.ts": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/sportmediiia/app.tsx": [
    "37223",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "4076"
  ],
  "./_geograffee/main/app.tsx": [
    "95508",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23509"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/styles": [
    "18476",
    9
  ],
  "./_competition/helpers/getCompetitionDate.ts": [
    "76662",
    9
  ],
  "./_deziiign/online/routesList.tsx": [
    "51217",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "2026"
  ],
  "./_competition/pages/ProjectsPage/CompetitionInfoPage": [
    "65548",
    9
  ],
  "./_deziiign/cgrave/const/CGRaveCompetitions.ts": [
    "97044",
    9,
    "15765"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-tags.tsx": [
    "22226",
    9,
    "99727"
  ],
  "./_deziiign/hsespace/routesList": [
    "82760",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31889"
  ],
  "./_deziiign/s-oriental/app": [
    "43791",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "39300"
  ],
  "./_deziiign/lmsmediiia/app.tsx": [
    "49241",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "99042"
  ],
  "./_deziiign/s-political-science/app.tsx": [
    "51367",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50188"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation.tsx": [
    "36014",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-authorDeziign.tsx": [
    "13598",
    9,
    "72339"
  ],
  "./_deziiign/urbanmediiia/app.tsx": [
    "22093",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5214"
  ],
  "./_deziiign/books/pages/sections/ps-buttons": [
    "94539",
    9,
    "48056"
  ],
  "./_deziiign/photomediiia/app": [
    "6213",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5478"
  ],
  "./_deziiign/prohse/app.tsx": [
    "9256",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23313"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListProjectsEdit": [
    "85441",
    9
  ],
  "./_deziiign/s-psychology/app": [
    "32336",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31145"
  ],
  "./_deziiign/hsespace/utils/index.ts": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/onlines/pages/readymag/english/intlTelInput": [
    "24471",
    9,
    "76604"
  ],
  "./_competition/pages/CreateCompetitionPage": [
    "40565",
    9,
    "23126"
  ],
  "./_competition/pages/CreateCompetitionPage/styles": [
    "31768",
    9
  ],
  "./_deziiign/fashionmediiia/app": [
    "96925",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "82734"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/flags.png": [
    "19831",
    1,
    "78652"
  ],
  "./_deziiign/dvadesign/styles": [
    "2739",
    9,
    "87120"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/OptionContentEditField.tsx": [
    "70009",
    9,
    "30818"
  ],
  "./_competition/pages/PreRegistrationResult/PreRegistrationResult.tsx": [
    "12225",
    9,
    "22056",
    "33754"
  ],
  "./_deziiign/prohse/routesList": [
    "20171",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21048"
  ],
  "./_deziiign/books/helpers/copyLink.ts": [
    "77885",
    9
  ],
  "./_deziiign/books/core/components/template/book-display-layout.tsx": [
    "70395",
    9,
    "52744"
  ],
  "./_deziiign/books/pages/BookListView": [
    "76584",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/s-chemistry/app.tsx": [
    "5001",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86130"
  ],
  "./_deziiign/books/core/components/bookCard/index": [
    "21273",
    9
  ],
  "./_competition/pages/PreRegistrationResult/": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/dvadesign/app": [
    "31062",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "86843"
  ],
  "./_deziiign/onlines/utils/": [
    "12216",
    9,
    "1953"
  ],
  "./_deziiign/books/pages/sections/ps-sub-information.tsx": [
    "12750",
    9,
    "82563"
  ],
  "./_deziiign/s-production/routesList.tsx": [
    "88157",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "11438"
  ],
  "./_deziiign/hsestart/styles": [
    "69730",
    9,
    "59551"
  ],
  "./_deziiign/iqmedia/app.tsx": [
    "5142",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "57563"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star3.svg": [
    "37310",
    1,
    "29587"
  ],
  "./_deziiign/continuumsite/app.tsx": [
    "36526",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "85059"
  ],
  "./_deziiign/books/routesList": [
    "26760",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64585"
  ],
  "./_deziiign/namesmediiia/routesList.tsx": [
    "89232",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "95145"
  ],
  "./_deziiign/onlines/app": [
    "29095",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "13836"
  ],
  "./_deziiign/school/routesList.tsx": [
    "262",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "87723"
  ],
  "./_deziiign/hsehh/routesList": [
    "11862",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "40283"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/damuseum/pages/roleAdmin/RoleAdminPage.tsx": [
    "16914",
    9,
    "99567"
  ],
  "./_deziiign/main/pages/projectDeziign/styles": [
    "16478",
    9,
    "13043"
  ],
  "./_deziiign/main/app": [
    "71236",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "47108",
    "20069"
  ],
  "./_deziiign/hsespacecreative/app": [
    "54370",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "26687"
  ],
  "./_deziiign/musicmediiia/app": [
    "62630",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "58923"
  ],
  "./_deziiign/awards/styles": [
    "37460",
    9,
    "98197"
  ],
  "./_deziiign/pro/app.tsx": [
    "31834",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "43559"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage.tsx": [
    "166",
    9
  ],
  "./_deziiign/s-advertising-and-pr/app.tsx": [
    "98286",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31267"
  ],
  "./_deziiign/books/core/components/helper/types/computed/ComputedBook": [
    "82452",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/changebg.svg": [
    "62674",
    1,
    "19919"
  ],
  "./_deziiign/damuseum/pages/EmployeesModerContext/EmployeesModerContext": [
    "62023",
    9,
    "35499",
    "96716"
  ],
  "./_deziiign/s-production/routesList": [
    "88157",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "11438"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArrayContentEditField": [
    "1116",
    9,
    "83917"
  ],
  "./_deziiign/onlines/pages/readymag/commonStyles.ts": [
    "28565",
    9,
    "72054"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/id.svg": [
    "5792",
    1,
    "24249"
  ],
  "./_deziiign/online/app": [
    "51165",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "53966"
  ],
  "./_deziiign/s-cognitive/app": [
    "94287",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "52100"
  ],
  "./_deziiign/kiiids/pages/roleAdmin/RoleAdminPage": [
    "52222",
    9,
    "92275"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/DvaDesignHeader.tsx": [
    "33655",
    9,
    "35004"
  ],
  "./_deziiign/s-international-relations/routesList": [
    "48390",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "99627"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPage": [
    "22108",
    9,
    "50333",
    "13357"
  ],
  "./_deziiign/books/core/common": [
    "62913",
    9,
    "82989"
  ],
  "./_deziiign/continuumsite/app": [
    "36526",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "85059"
  ],
  "./_deziiign/booksmediiia/app": [
    "25247",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71668"
  ],
  "./_deziiign/conceptmediiia/app": [
    "19869",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86702"
  ],
  "./_deziiign/awards/pages/EmployeesContext/index": [
    "31656",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "28689"
  ],
  "./_deziiign/creativemediiia/routesList": [
    "92375",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "77724"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star4.svg": [
    "54689",
    1,
    "71533"
  ],
  "./_deziiign/continuumsite/styles": [
    "5915",
    9,
    "9064"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookPlusIcon": [
    "37305",
    9
  ],
  "./_deziiign/hseanimation/routesList.tsx": [
    "27072",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "55417"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury": [
    "71795",
    9
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArray2ContentEditField.tsx": [
    "81290",
    9,
    "55863"
  ],
  "./_deziiign/s-philology/app": [
    "24826",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "10887"
  ],
  "./_deziiign/books/pages/BookEdit/index.ts": [
    "25525",
    9,
    "44086"
  ],
  "./_deziiign/books/core/components/shareButton/shareButton.tsx": [
    "88300",
    9,
    "45757"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/DvaDesignFooter": [
    "94043",
    9,
    "87464"
  ],
  "./_competition/components/CompetitionFormSuccess": [
    "2402",
    9,
    "63231"
  ],
  "./_deziiign/galllleryart/styles": [
    "78199",
    9,
    "52700"
  ],
  "./_deziiign/damuseum/routesList": [
    "99737",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35074"
  ],
  "./_competition/pages/PreRegistrationResult/style": [
    "33555",
    7,
    "66128"
  ],
  "./_deziiign/awards/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "70104",
    9,
    "35499",
    "55809"
  ],
  "./_deziiign/school/styles.tsx": [
    "6510",
    9,
    "40355"
  ],
  "./_geograffee/__COMMON__/commonRoutesEducation.tsx": [
    "42508",
    9,
    "50323",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "9452",
    "66673",
    "35499",
    "59037",
    "59017",
    "60204",
    "73645",
    "43709"
  ],
  "./_deziiign/greenaward/components/IndexTitle.tsx": [
    "69371",
    9,
    "88360"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCard.tsx": [
    "47486",
    9
  ],
  "./_deziiign/booksgallllery/ExtraPage/ExtraPage": [
    "79407",
    9,
    "56900"
  ],
  "./_deziiign/monalisatravels/routesList": [
    "58745",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "93410"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionGrid": [
    "1268",
    9
  ],
  "./_deziiign/main/pages/manageTag/ManageTagPage": [
    "88716",
    9,
    "3157",
    "61341"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBar.tsx": [
    "89260",
    9,
    "13908",
    "21655",
    "21565"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/styles": [
    "1094",
    9,
    "1979",
    "64171"
  ],
  "./_deziiign/s-biology/app": [
    "72594",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "77743"
  ],
  "./_deziiign/awards/routesList": [
    "80164",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "84709"
  ],
  "./_competition/routesList": [
    "1875",
    9,
    "78074",
    "56496"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module3.svg": [
    "79202",
    1,
    "35967"
  ],
  "./_deziiign/s-chemistry/routesList.tsx": [
    "77800",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "10897"
  ],
  "./_deziiign/prohse/routesList.tsx": [
    "20171",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21048"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBarLayout.tsx": [
    "80714",
    9,
    "51735"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/what_is_branding_sm.jpg": [
    "81172",
    1,
    "55637"
  ],
  "./_deziiign/lpudesign/app": [
    "34912",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "36921"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-more-title": [
    "20187",
    9,
    "69512"
  ],
  "./_deziiign/books/core/components/booksSearchBar/": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/damuseum/styles.tsx": [
    "32402",
    9,
    "67110"
  ],
  "./_deziiign/naturemediiia/app": [
    "78614",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "51835"
  ],
  "./_deziiign/damuseum/utils/index.ts": [
    "8895",
    9,
    "67156"
  ],
  "./_deziiign/books/core/components/booksSearchBar/index": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/CombatEntitiesContentEditField.tsx": [
    "40683",
    9,
    "38776"
  ],
  "./_deziiign/sciencemediiia/routesList": [
    "38466",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "7775"
  ],
  "./_competition/components/CompetitionFormSuccess.tsx": [
    "2402",
    9,
    "63231"
  ],
  "./_competition/pages/ShortListPage/index.ts": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/hsespace/styles": [
    "98752",
    9,
    "12249"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationOneReadymag.svg": [
    "46855",
    1,
    "29356"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCard": [
    "47486",
    9
  ],
  "./_deziiign/lab/app": [
    "14678",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44571"
  ],
  "./_competition/pages/AllCompetitionsPage/index": [
    "60929",
    9,
    "14618"
  ],
  "./_deziiign/s-cognitive/app.tsx": [
    "94287",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "52100"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookVerticalCardIcon": [
    "1113",
    9
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/map": [
    "72684",
    9,
    "6602",
    "96678",
    "52477"
  ],
  "./_deziiign/books/core/components/grid/": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/exams/app.tsx": [
    "78503",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "57516"
  ],
  "./_deziiign/hsecreative/app": [
    "90600",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "38161"
  ],
  "./_competition/pages/SeasonsAdmin/SeasonsAdminPage": [
    "908",
    9,
    "10717"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionContexts.ts": [
    "2696",
    9
  ],
  "./_deziiign/books/core/components/booksSearchBar": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/kiiids/styles.tsx": [
    "19025",
    9,
    "99402"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Categories.tsx": [
    "93506",
    9
  ],
  "./_deziiign/books/core/components/booksSearchBar/index.ts": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/books/core/components/helper/bookEvents.ts": [
    "97590",
    9,
    "73051"
  ],
  "./_deziiign/hsedesign/styles.tsx": [
    "91408",
    9,
    "49545"
  ],
  "./_geograffee/hsealumni/app.tsx": [
    "78689",
    9,
    "83762",
    "50323",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "97775",
    "92287",
    "71237",
    "9452",
    "66673",
    "35499",
    "59037",
    "59017",
    "60204",
    "73645",
    "27354"
  ],
  "./_deziiign/galllleryart/app.tsx": [
    "94354",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "35727"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/pen.svg": [
    "99569",
    1,
    "42218"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListProjectsEdit.tsx": [
    "85441",
    9
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookVerticalCardIcon.tsx": [
    "1113",
    9
  ],
  "./_deziiign/books/routesList.tsx": [
    "26760",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64585"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star1.svg": [
    "55036",
    1,
    "19789"
  ],
  "./_competition/pages/AllCompetitionsPage/sections/section-cgrave": [
    "10954",
    9,
    "2967"
  ],
  "./_deziiign/onlines/pages/readymag/english/intlTelInput.ts": [
    "24471",
    9,
    "76604"
  ],
  "./_deziiign/online/utils/": [
    "97367",
    9
  ],
  "./_deziiign/monalisatravels/app": [
    "23293",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "77655"
  ],
  "./_deziiign/fashion/routesList": [
    "97862",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31947"
  ],
  "./_deziiign/aimediiia/routesList": [
    "83870",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "42291"
  ],
  "./_deziiign/books/pages/tag/tagBookListViewLayout": [
    "85154",
    9,
    "18751"
  ],
  "./_deziiign/awards/pages/EmployeesContext": [
    "31656",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "28689"
  ],
  "./_deziiign/sportmediiia/routesList": [
    "81858",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "19743"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveJuriesPage.tsx": [
    "22570",
    9,
    "83863"
  ],
  "./_deziiign/hsedesign/routesList": [
    "30078",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "13779"
  ],
  "./_deziiign/s-production/app.tsx": [
    "42265",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "46699"
  ],
  "./_deziiign/s-mathematics/app.tsx": [
    "63417",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "3138"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/styles": [
    "93487",
    9,
    "77316"
  ],
  "./_deziiign/books/core/common.ts": [
    "62913",
    9,
    "82989"
  ],
  "./_competition/helpers/getCompetitionStatus.ts": [
    "30100",
    9
  ],
  "./_geograffee/__COMMON__/bookRoutes": [
    "33912",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "3938",
    "45633"
  ],
  "./_deziiign/hsehh/app": [
    "3651",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "94624"
  ],
  "./_competition/app.tsx": [
    "95668",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "13779",
    "64085"
  ],
  "./_deziiign/books/core/hook/api/useBookList": [
    "72617",
    9,
    "96850"
  ],
  "./_deziiign/hsespacecreative/app.tsx": [
    "54370",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "26687"
  ],
  "./_competition/pages/PreRegistrationResult/index": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/s-chemistry/routesList": [
    "77800",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "10897"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/rm.svg": [
    "87720",
    1,
    "29873"
  ],
  "./_deziiign/hsehh/routesList.tsx": [
    "11862",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "40283"
  ],
  "./_competition/components/style.ts": [
    "10301",
    9
  ],
  "./_deziiign/s-philosophy/app.tsx": [
    "9222",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50155"
  ],
  "./_deziiign/s-media/app.tsx": [
    "46343",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "14220"
  ],
  "./_deziiign/school/pages/init": [
    "74957",
    9,
    "48382"
  ],
  "./_deziiign/books/core/components/template/book-container-layout": [
    "74194",
    9,
    "55247"
  ],
  "./_deziiign/eventmediiia/routesList": [
    "4152",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "79073"
  ],
  "./_deziiign/s-physics/routesList.tsx": [
    "36487",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "39212"
  ],
  "./_deziiign/s-hsetto/app.tsx": [
    "97284",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "94949"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/MobileReadymag.svg": [
    "65300",
    1,
    "37804"
  ],
  "./_deziiign/hsespace/routesList.tsx": [
    "82760",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31889"
  ],
  "./_deziiign/booksgallllery/ExtraPage/ExtraPage.tsx": [
    "79407",
    9,
    "56900"
  ],
  "./_deziiign/foodmediiia/routesList": [
    "62124",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "53245"
  ],
  "./_competition/pages/ShortListPage/assets/LaurelWreathLeft.svg": [
    "865",
    1,
    "68250"
  ],
  "./_competition/pages/CreateCompetitionPage/index": [
    "40565",
    9,
    "23126"
  ],
  "./_competition/pages/ProjectsPage/index.ts": [
    "31708",
    9,
    "99309"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionAddTabs": [
    "1325",
    9
  ],
  "./_deziiign/conceptmediiia/app.tsx": [
    "19869",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86702"
  ],
  "./_deziiign/greenaward/app.tsx": [
    "39231",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "84116"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plantbig.svg": [
    "4083",
    1,
    "42736"
  ],
  "./_geograffee/dafes/app": [
    "76242",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "37071"
  ],
  "./_deziiign/superpuper/app": [
    "31858",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31887"
  ],
  "./_deziiign/hsespacecreative/routesList": [
    "9137",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "27402"
  ],
  "./_deziiign/booksgallllery/ExtraPage/": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-bottom": [
    "84958",
    9,
    "19955"
  ],
  "./_deziiign/books/pages/BookChapterCreate/index.ts": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/s-advertising-and-pr/app": [
    "98286",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31267"
  ],
  "./_deziiign/s-media/app": [
    "46343",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "14220"
  ],
  "./_deziiign/hsecreative/routesList.tsx": [
    "23307",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "99416"
  ],
  "./_deziiign/greenaward/utils/": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/hsedesign/utils/index": [
    "46106",
    9
  ],
  "./_deziiign/onlines/pages/readymag/commonStyles": [
    "28565",
    9,
    "72054"
  ],
  "./_deziiign/s-arthistory/app": [
    "56821",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "28927"
  ],
  "./_deziiign/iqmedia/routesList.tsx": [
    "70364",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "96525"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext": [
    "51397",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "67270"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext/index": [
    "4817",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "49674"
  ],
  "./_deziiign/cgrave/styles": [
    "1380",
    9,
    "5093"
  ],
  "./_deziiign/dvadesign/routesList.tsx": [
    "13069",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "53918"
  ],
  "./_deziiign/s-computer-science-and-engineering/app": [
    "24643",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "10720"
  ],
  "./_geograffee/main/routesList.tsx": [
    "29087",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "18900"
  ],
  "./_deziiign/sportmediiia/routesList.tsx": [
    "81858",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "19743"
  ],
  "./_competition/pages/CompetitionResultsPage/CompetitionResultsPage": [
    "10235",
    9,
    "22056"
  ],
  "./_deziiign/s-sociology/app.tsx": [
    "67953",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44234"
  ],
  "./_deziiign/dvadesign/styles.ts": [
    "2739",
    9,
    "87120"
  ],
  "./_deziiign/main/pages/admin/AdminPage.tsx": [
    "63176",
    9,
    "79665"
  ],
  "./_deziiign/fashionmediiia/app.tsx": [
    "96925",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "82734"
  ],
  "./_deziiign/books/core/components/tooltips/index.ts": [
    "40356",
    9
  ],
  "./_deziiign/s-history/app.tsx": [
    "25571",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83552"
  ],
  "./_deziiign/hsedesign/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "53649",
    9,
    "17642"
  ],
  "./_deziiign/cinemediiia/app.tsx": [
    "27588",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50533"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationOverviewReadymag.svg": [
    "54856",
    1,
    "61457"
  ],
  "./_geograffee/__COMMON__/bookRoutes.tsx": [
    "33912",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "3938",
    "45633"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionAddTabs.ts": [
    "1325",
    9
  ],
  "./_competition/pages/PreRegistrationResult/PreRegistrationResult": [
    "12225",
    9,
    "22056",
    "33754"
  ],
  "./_deziiign/storiesmediiia/app.tsx": [
    "21600",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71865"
  ],
  "./_deziiign/adcrdafesnet/app.tsx": [
    "72893",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "68398"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveNomineesPage.tsx": [
    "69662",
    9,
    "65235"
  ],
  "./_deziiign/mediiia/app": [
    "18689",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "24218"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/styles.ts": [
    "60017",
    9,
    "1979",
    "10314"
  ],
  "./_competition/pages/AllOpenCalls.tsx": [
    "62910",
    9,
    "2003"
  ],
  "./_deziiign/books/pages/BookEdit/sections/styles.ts": [
    "14954",
    9
  ],
  "./_deziiign/awards/pages/EmployeesModerContext/EmployeesModerContext": [
    "70104",
    9,
    "35499",
    "55809"
  ],
  "./_deziiign/s-architect/routesList": [
    "52833",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "74394"
  ],
  "./_deziiign/s-public-administration/app": [
    "21533",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "39662"
  ],
  "./_deziiign/hsedesign/components/IndexTitle": [
    "91797",
    9
  ],
  "./_deziiign/kiiids/utils/": [
    "25179",
    9,
    "14824"
  ],
  "./_deziiign/galllleryart/app": [
    "94354",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "35727"
  ],
  "./_deziiign/booksmediiia/routesList.tsx": [
    "69210",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44807"
  ],
  "./_deziiign/s-production/app": [
    "42265",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "46699"
  ],
  "./_deziiign/s-management/routesList.tsx": [
    "86269",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35054"
  ],
  "./_deziiign/exams/routesList": [
    "35170",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "56031"
  ],
  "./_deziiign/s-architect/app": [
    "30162",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "9775"
  ],
  "./_geograffee/__COMMON__/commonRoutesEducation": [
    "42508",
    9,
    "50323",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "9452",
    "66673",
    "35499",
    "59037",
    "59017",
    "60204",
    "73645",
    "43709"
  ],
  "./_deziiign/awards/pages/roleAdmin/RoleAdminPage": [
    "51697",
    9,
    "73706"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/index.ts": [
    "71795",
    9
  ],
  "./_deziiign/books/pages/sections/ps-commerce": [
    "21934",
    9,
    "51811"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/EmployeesContext": [
    "33981",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "73358"
  ],
  "./_deziiign/main/pages/moderHseView/ProjectTilesMapDeziiign": [
    "61848",
    9,
    "45825"
  ],
  "./_competition/helpers/getCompetitionStatus": [
    "30100",
    9
  ],
  "./_deziiign/books/core/components/shareButton/shareButton": [
    "88300",
    9,
    "45757"
  ],
  "./_deziiign/booksgallllery/routesList": [
    "14518",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "98363"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-more-title.tsx": [
    "20187",
    9,
    "69512"
  ],
  "./_deziiign/storiesmediiia/app": [
    "21600",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71865"
  ],
  "./_deziiign/books/pages/sections/ps-sub-information": [
    "12750",
    9,
    "82563"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/index.ts": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/lmshse/routesList.tsx": [
    "89406",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21267"
  ],
  "./_deziiign/awards/components/IndexTitle.tsx": [
    "81233",
    9,
    "96362"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-title": [
    "35075",
    9,
    "95008"
  ],
  "./_deziiign/sciencemediiia/routesList.tsx": [
    "38466",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "7775"
  ],
  "./_competition/pages/AllCompetitionsPage/components/HintInfo.tsx": [
    "70085",
    9
  ],
  "./_deziiign/hsedesign/utils": [
    "46106",
    9
  ],
  "./_deziiign/books/pages/BookEdit/index": [
    "25525",
    9,
    "44086"
  ],
  "./_deziiign/brnd/app": [
    "8109",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23902"
  ],
  "./_deziiign/historymediiia/routesList.tsx": [
    "93384",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "24881"
  ],
  "./_competition/components/imageTS.png": [
    "12968",
    1,
    "9489"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/pin1.svg": [
    "60232",
    1,
    "46225"
  ],
  "./_deziiign/books/core/components/designerSearch/DesignerSearch": [
    "10268",
    9,
    "21655",
    "42029"
  ],
  "./_deziiign/books/pages/BookEdit/styles.ts": [
    "5171",
    9
  ],
  "./_deziiign/books/pages/BookView/components/BookTools.tsx": [
    "67079",
    9,
    "2325"
  ],
  "./_deziiign/main/pages/projectDeziign/components/ProjectImage": [
    "77159",
    9,
    "6636"
  ],
  "./_deziiign/books/core/components/datePickerRange/styles": [
    "63545",
    9,
    "82850"
  ],
  "./_competition/app": [
    "95668",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "13779",
    "64085"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/styles": [
    "60017",
    9,
    "1979",
    "10314"
  ],
  "./_deziiign/hsedesign/routesList.tsx": [
    "30078",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "13779"
  ],
  "./_deziiign/s-biology/routesList": [
    "28257",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "73402"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/CategoryEdit.tsx": [
    "38310",
    9
  ],
  "./_deziiign/onlines/pages/readymag/turkey/ReadymagPageTR": [
    "36272",
    9,
    "1979",
    "10314",
    "52393"
  ],
  "./_deziiign/main/pages/projectDeziign/": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_deziiign/books/pages/BookView/components/BookHeader.tsx": [
    "6371",
    9,
    "95360"
  ],
  "./_competition/pages/ShortListPage/PreShortListPage": [
    "97566",
    9
  ],
  "./_competition/pages/ShortListPage/ShortListPage": [
    "37613",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionEditPlus.tsx": [
    "89004",
    9,
    "52701"
  ],
  "./_deziiign/books/core/components/designerSearch/designerSearchAuth.tsx": [
    "3978",
    9,
    "21655"
  ],
  "./_deziiign/s-computer-science-and-engineering/routesList.tsx": [
    "81206",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "66107"
  ],
  "./_deziiign/s-pro/routesList.tsx": [
    "41741",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35134"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/styles": [
    "86409",
    9,
    "94930"
  ],
  "./_deziiign/books/pages/tag/tagBookListView": [
    "29236",
    9,
    "13908",
    "21655",
    "21565",
    "57493"
  ],
  "./_deziiign/game/routesList.tsx": [
    "71368",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "75345"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module2.svg": [
    "82931",
    1,
    "65936"
  ],
  "./_deziiign/s-political-science/app": [
    "51367",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50188"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/bgDvaDesign.jpg": [
    "63081",
    1,
    "72658"
  ],
  "./_competition/components/CompetitionDropdown": [
    "22878",
    9
  ],
  "./_deziiign/hsestart/routesList.tsx": [
    "94962",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "63279"
  ],
  "./_deziiign/namesmediiia/routesList": [
    "89232",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "95145"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagContentEditTextField.tsx": [
    "14771",
    9,
    "79056"
  ],
  "./_deziiign/cgrave/pages/CgRaveNomineesPage.tsx": [
    "11278",
    9,
    "8739"
  ],
  "./_competition/pages/ShortListPage": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/exams/routesList.tsx": [
    "35170",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "56031"
  ],
  "./_deziiign/lmsmediiia/app": [
    "49241",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "99042"
  ],
  "./_deziiign/s-public-administration/routesList": [
    "96916",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "51125"
  ],
  "./_competition/components/CompetitionDropdown.tsx": [
    "22878",
    9
  ],
  "./_deziiign/s-geography/app.tsx": [
    "84909",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "12670"
  ],
  "./_deziiign/books/core/components/grid/index": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/booksgallllery/app": [
    "76643",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "66688"
  ],
  "./_deziiign/sciencemediiia/app.tsx": [
    "65447",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "58028"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArrayContentEditField.tsx": [
    "1116",
    9,
    "83917"
  ],
  "./_deziiign/damuseum/utils": [
    "8895",
    9,
    "67156"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/searchblack.svg": [
    "93583",
    1,
    "87428"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/index.ts": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/awards/pages/EmployeesContext/EmployeesContext.tsx": [
    "59929",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "56043"
  ],
  "./_deziiign/books/pages/BookChapterCreate": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/books/pages/BookListView/index": [
    "76584",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/styles.tsx": [
    "20509",
    9
  ],
  "./_deziiign/online/utils/index": [
    "97367",
    9
  ],
  "./_deziiign/hsecreativehub/routesList": [
    "71242",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "57303"
  ],
  "./_deziiign/galllleryart/routesList": [
    "43137",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "93914"
  ],
  "./_deziiign/designmediiia/routesList.tsx": [
    "17398",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "3323"
  ],
  "./_deziiign/main/pages/moderHseView/moderHseView.tsx": [
    "53627",
    9,
    "99272"
  ],
  "./_deziiign/s-fashion/app": [
    "40127",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "93492"
  ],
  "./_deziiign/lmshsecreative/app.tsx": [
    "59520",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64665"
  ],
  "./_deziiign/s-international-relations/app": [
    "57715",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "11408"
  ],
  "./_deziiign/s-music/app": [
    "62310",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "98411"
  ],
  "./_deziiign/superpuper/app.tsx": [
    "31858",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31887"
  ],
  "./_deziiign/s-cognitive/routesList": [
    "92970",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6167"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/searchsm.svg": [
    "39150",
    1,
    "91907"
  ],
  "./_competition/pages/ShortListPage/PreShortListPage.tsx": [
    "97566",
    9
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/styles": [
    "20509",
    9
  ],
  "./_deziiign/adcrdafesnet/routesList.tsx": [
    "84852",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "39797"
  ],
  "./_deziiign/books/core/components/bookCard": [
    "21273",
    9
  ],
  "./_deziiign/superpuper/routesList.tsx": [
    "76673",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23130"
  ],
  "./_deziiign/s-sociology/app": [
    "67953",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44234"
  ],
  "./_deziiign/greenaward/app": [
    "39231",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "84116"
  ],
  "./_deziiign/s-media/routesList": [
    "88674",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "89023"
  ],
  "./_competition/pages/JuryPage/": [
    "5122",
    9,
    "91967"
  ],
  "./_competition/const": [
    "19408",
    9
  ],
  "./_deziiign/s-chemistry/app": [
    "5001",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86130"
  ],
  "./_deziiign/books/app.tsx": [
    "52905",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64585"
  ],
  "./_deziiign/lpudesign/routesList.tsx": [
    "56163",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "42368"
  ],
  "./_deziiign/onlines/pages/readymag/kz/ReadymagPageKZ": [
    "45660",
    9,
    "1979",
    "13918",
    "42722",
    "98042",
    "32301"
  ],
  "./_deziiign/lpudesign/styles.tsx": [
    "72095",
    9,
    "29364"
  ],
  "./_deziiign/lpudesign/app.tsx": [
    "34912",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "36921"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-image.tsx": [
    "75542",
    9,
    "13243"
  ],
  "./_competition/pages/AllCompetitionsPage/components/HintInfo": [
    "70085",
    9
  ],
  "./_deziiign/onlines/pages/readymag/library/LibraryPage": [
    "8276",
    9,
    "1979",
    "13918",
    "63342",
    "95541"
  ],
  "./_deziiign/s-culturology/routesList": [
    "49467",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "76872"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/camera.svg": [
    "12413",
    1,
    "93262"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plant.svg": [
    "59903",
    1,
    "7540"
  ],
  "./_deziiign/musicmediiia/routesList": [
    "17469",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23406"
  ],
  "./_deziiign/greenaward/utils/index.ts": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/hsespace/utils": [
    "93514",
    9,
    "65303"
  ],
  "./_competition/pages/CompetitionTable/CompetitionTable.tsx": [
    "72383",
    9,
    "22056",
    "38708"
  ],
  "./_deziiign/books/core/components/helper/types/computed/ComputedBook.ts": [
    "82452",
    9
  ],
  "./_deziiign/hsespacefilm/routesList.tsx": [
    "18438",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "555"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Platforms.tsx": [
    "59628",
    9
  ],
  "./_deziiign/s-urban-development/app": [
    "69291",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "61528"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionJuryCard.tsx": [
    "21919",
    9
  ],
  "./_deziiign/main/pages/moderHseView/index": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/s-geography/routesList": [
    "10596",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97093"
  ],
  "./_competition/pages/CompetitionTable/CompetitionTable": [
    "72383",
    9,
    "22056",
    "38708"
  ],
  "./_competition/pages/ProjectsPage/index": [
    "31708",
    9,
    "99309"
  ],
  "./_competition/components/CompetitionTagLine.tsx": [
    "23659",
    9
  ],
  "./_deziiign/main/pages/moderView/moderView.tsx": [
    "29397",
    9,
    "51382"
  ],
  "./_deziiign/s-urban-development/routesList": [
    "14622",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "14419"
  ],
  "./_deziiign/onlines/utils": [
    "12216",
    9,
    "1953"
  ],
  "./_competition/pages/ShortListPage/styles.ts": [
    "42270",
    9
  ],
  "./_deziiign/books/core/components/bookCard/assets/book-more-circle.svg": [
    "84667",
    1,
    "66760"
  ],
  "./_competition/pages/AllCompetitionsPage/styled.ts": [
    "70740",
    9
  ],
  "./_competition/pages/EmptyPage": [
    "90798",
    9,
    "81251"
  ],
  "./_deziiign/s-advertising-and-pr/routesList": [
    "2725",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "49510"
  ],
  "./_competition/helpers/getCompetitionDate": [
    "76662",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/competitionTagsCloud": [
    "40443",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateRaitingCompetiton": [
    "46895",
    9,
    "50333",
    "96228"
  ],
  "./_deziiign/mediiia/app.tsx": [
    "18689",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "24218"
  ],
  "./_geograffee/dafes/routesList": [
    "58305",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "43290"
  ],
  "./_deziiign/s-economy/app": [
    "30587",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "69032"
  ],
  "./_deziiign/exams/app": [
    "78503",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "57516"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/EmployeesModerContext": [
    "95636",
    9,
    "35499",
    "28821"
  ],
  "./_deziiign/hsedesign/pages/roleAdmin/RoleAdminPage": [
    "2925",
    9,
    "99358"
  ],
  "./_deziiign/s-economy/routesList": [
    "59950",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "8771"
  ],
  "./_deziiign/onlines/pages/readymag/images/OnlinesSchedule.pdf": [
    "11664",
    1,
    "45321"
  ],
  "./_deziiign/designmediiia/routesList": [
    "17398",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "3323"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/index": [
    "51397",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "67270"
  ],
  "./_deziiign/s-hsetto/app": [
    "97284",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "94949"
  ],
  "./_deziiign/s-philology/app.tsx": [
    "24826",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "10887"
  ],
  "./_deziiign/s-jurisprudence/app.tsx": [
    "87039",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64605"
  ],
  "./_deziiign/s-physics/app": [
    "76764",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "89997"
  ],
  "./_deziiign/hsecolors/app.tsx": [
    "19735",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "43452"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionView": [
    "255",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionPage.tsx": [
    "18314",
    9
  ],
  "./_competition/pages/CompetitionResultsPage/": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/s-software-engineering/app": [
    "99790",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "14115"
  ],
  "./_competition/pages/ShortListPage/index": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/hsespace/styles.tsx": [
    "98752",
    9,
    "12249"
  ],
  "./_deziiign/books/core/components/bookCard/style": [
    "94938",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/iqmedia/app": [
    "5142",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "57563"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/styles": [
    "63011",
    9
  ],
  "./_competition/components/SendProjectButton": [
    "26709",
    9
  ],
  "./_deziiign/books/core/components/template/book-container-layout.tsx": [
    "74194",
    9,
    "55247"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext/EmployeesContext": [
    "32497",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "32522"
  ],
  "./_deziiign/s-oriental/app.tsx": [
    "43791",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "39300"
  ],
  "./_deziiign/s-sociology/routesList": [
    "82256",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "26089"
  ],
  "./_competition/pages/CreateCompetitionPage/styles.tsx": [
    "31768",
    9
  ],
  "./_competition/components/CompetitionTagLine": [
    "23659",
    9
  ],
  "./_deziiign/s-philology/routesList": [
    "22217",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "1490"
  ],
  "./_competition/components/ImageMob.jpg": [
    "10213",
    1,
    "3782"
  ],
  "./_deziiign/lab/routesList": [
    "59821",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "68990"
  ],
  "./_deziiign/books/pages/sections/ps-commerce.tsx": [
    "21934",
    9,
    "51811"
  ],
  "./_competition/helpers/getDaysToFinish": [
    "20572",
    9
  ],
  "./_deziiign/hsedesign/app.tsx": [
    "66841",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "13779",
    "99554"
  ],
  "./_deziiign/online/app.tsx": [
    "51165",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "53966"
  ],
  "./_deziiign/awards/utils/": [
    "97022",
    9,
    "7539"
  ],
  "./_deziiign/books/pages/sections/assets/alert.svg": [
    "87408",
    1,
    "24681"
  ],
  "./_deziiign/s-fashion/routesList.tsx": [
    "7386",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "80679"
  ],
  "./_competition/pages/CompetitionTable/index.ts": [
    "69432",
    9,
    "22056",
    "38708",
    "91137"
  ],
  "./_deziiign/booksgallllery/ExtraPage/index.ts": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/week.svg": [
    "38988",
    1,
    "55677"
  ],
  "./_deziiign/books/pages/tag/tagBookListView.tsx": [
    "29236",
    9,
    "13908",
    "21655",
    "21565",
    "57493"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/DvaDesignFooter.tsx": [
    "94043",
    9,
    "87464"
  ],
  "./_deziiign/main/pages/eduTagAdmin/EduTagAdminPage.tsx": [
    "97728",
    9,
    "27769"
  ],
  "./_deziiign/fashionmediiia/routesList.tsx": [
    "77396",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "7477"
  ],
  "./_deziiign/hsecreative/app.tsx": [
    "90600",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "38161"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/hsestart/app.tsx": [
    "36503",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "85244"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagContentEditTextField": [
    "14771",
    9,
    "79056"
  ],
  "./_deziiign/hsedesign/pages/StatisticsPage/StatisticsPage.tsx": [
    "32042",
    9,
    "13908",
    "26324",
    "10039"
  ],
  "./_deziiign/onlines/pages/readymag/video/styles.ts": [
    "48516",
    9,
    "73637"
  ],
  "./_deziiign/s-mathematics/routesList.tsx": [
    "82264",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "15905"
  ],
  "./_deziiign/continuumsite/routesList": [
    "97765",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6886"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/TagsTypeSwitcher": [
    "51152",
    9
  ],
  "./_deziiign/main/pages/eduTagAdmin/index": [
    "25672",
    9,
    "27769",
    "32049"
  ],
  "./_deziiign/s-architect/app.tsx": [
    "30162",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "9775"
  ],
  "./_deziiign/online/utils/index.ts": [
    "97367",
    9
  ],
  "./_deziiign/brnd/routesList.tsx": [
    "59684",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21733"
  ],
  "./_deziiign/s-international-relations/app.tsx": [
    "57715",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "11408"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/DvaDesignHeader": [
    "33655",
    9,
    "35004"
  ],
  "./_deziiign/books/core/components/template/book-display-layout": [
    "70395",
    9,
    "52744"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/EmployeesContext.tsx": [
    "33981",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "73358"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ae.svg": [
    "75721",
    1,
    "33106"
  ],
  "./_competition/pages/AllCompetitionsPage/types.ts": [
    "29334",
    9
  ],
  "./_deziiign/books/core/components/bookCard/bookCard": [
    "35468",
    9
  ],
  "./_deziiign/s-advertising-and-pr/routesList.tsx": [
    "2725",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "49510"
  ],
  "./_geograffee/places/pages/tagPlaces/TagPlacesPage": [
    "87819",
    9,
    "14488"
  ],
  "./_deziiign/main/pages/moderView/": [
    "15597",
    9,
    "51382",
    "70494"
  ],
  "./_deziiign/lmsmediiia/routesList": [
    "74328",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54209"
  ],
  "./_deziiign/books/pages/BookListView/index.ts": [
    "76584",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/foodmediiia/app.tsx": [
    "86805",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "59126"
  ],
  "./_deziiign/books/core/components/bookCard/style.ts": [
    "94938",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module4.svg": [
    "7725",
    1,
    "96798"
  ],
  "./_deziiign/books/core/book-delegate": [
    "88325",
    9
  ],
  "./_deziiign/eventmediiia/app": [
    "98329",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5890"
  ],
  "./_deziiign/greenaward/routesList.tsx": [
    "29293",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23591"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/assets/next.svg": [
    "66407",
    1,
    "24780"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/s-cognitive/routesList.tsx": [
    "92970",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6167"
  ],
  "./_deziiign/onlines/utils/index.ts": [
    "12216",
    9,
    "1953"
  ],
  "./_deziiign/s-computer-science-and-engineering/routesList": [
    "81206",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "66107"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/FloatingPager.tsx": [
    "85524",
    9
  ],
  "./_deziiign/school/app.tsx": [
    "46931",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44080"
  ],
  "./_deziiign/books/core/components/grid/index.tsx": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/ageytomesh/routesList.tsx": [
    "92044",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "67741"
  ],
  "./_deziiign/awards/pages/EmployeesContext/index.tsx": [
    "31656",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "28689"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext": [
    "67884",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "11325"
  ],
  "./_deziiign/main/styles.tsx": [
    "94163",
    9,
    "28592"
  ],
  "./_deziiign/s-music/app.tsx": [
    "62310",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "98411"
  ],
  "./_deziiign/books/core/components/booksSearchBar/style": [
    "17998",
    9,
    "56067"
  ],
  "./_deziiign/greenaward/styles": [
    "52890",
    9,
    "32455"
  ],
  "./_deziiign/onlines/pages/readymag/kz/stylesKZ": [
    "60449",
    9,
    "1979",
    "13918",
    "98042"
  ],
  "./_deziiign/books/core/components/controllers/BooksButchController": [
    "90929",
    9,
    "68778"
  ],
  "./_deziiign/creativemediiia/routesList.tsx": [
    "92375",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "77724"
  ],
  "./_deziiign/continuumsite/img/image_1920.png": [
    "89373",
    1,
    "48046"
  ],
  "./_competition/pages/SeasonsAdmin/SeasonsAdminPage.tsx": [
    "908",
    9,
    "10717"
  ],
  "./_deziiign/damuseum/utils/": [
    "8895",
    9,
    "67156"
  ],
  "./_deziiign/books/core/components/tooltips": [
    "40356",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-image": [
    "75542",
    9,
    "13243"
  ],
  "./_competition/pages/PreRegistrationResult/style.ts": [
    "33555",
    7,
    "66128"
  ],
  "./_deziiign/hsespace/app.tsx": [
    "46345",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "22386"
  ],
  "./_deziiign/online/styles.tsx": [
    "10509",
    9,
    "50718"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/reducer/reducer.ts": [
    "68649",
    9,
    "41906"
  ],
  "./_deziiign/awards/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "56581",
    9,
    "16646"
  ],
  "./_deziiign/books/pages/BookView/components/MainBookTitle.tsx": [
    "53341",
    9
  ],
  "./_deziiign/books/core/components/template/book-container-layout.styles.tsx": [
    "5703",
    9,
    "1877"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/": [
    "71795",
    9
  ],
  "./_deziiign/s-pro/routesList": [
    "41741",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35134"
  ],
  "./_geograffee/academy/routesList.tsx": [
    "28768",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "71769"
  ],
  "./_deziiign/online/routesList": [
    "51217",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "2026"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPage.tsx": [
    "22108",
    9,
    "50333",
    "13357"
  ],
  "./_competition/pages/CompetitionTable/": [
    "69432",
    9,
    "22056",
    "38708",
    "91137"
  ],
  "./_deziiign/fashion/routesList.tsx": [
    "97862",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31947"
  ],
  "./_deziiign/onlines/utils/index": [
    "12216",
    9,
    "1953"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/": [
    "51397",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "67270"
  ],
  "./_deziiign/s-software-engineering/routesList": [
    "45829",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "5318"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plus.svg": [
    "81440",
    1,
    "40729"
  ],
  "./_deziiign/s-history/routesList": [
    "74294",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "58971"
  ],
  "./_deziiign/hsespace/utils/index": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module1.svg": [
    "21920",
    1,
    "80697"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibraryPage.tsx": [
    "8276",
    9,
    "1979",
    "13918",
    "63342",
    "95541"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateRaitingCompetiton.tsx": [
    "46895",
    9,
    "50333",
    "96228"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/index": [
    "71795",
    9
  ],
  "./_deziiign/hsestart/app": [
    "36503",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "85244"
  ],
  "./_competition/pages/ShortListPage/styles": [
    "42270",
    9
  ],
  "./_competition/components/TellingStoriesSuccess.tsx": [
    "43479",
    9,
    "10684"
  ],
  "./_deziiign/greenaward/routesList": [
    "29293",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23591"
  ],
  "./_competition/pages/web.svg": [
    "79274",
    1,
    "14519"
  ],
  "./_deziiign/lmshse/app": [
    "59755",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "7512"
  ],
  "./_geograffee/main/app": [
    "95508",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23509"
  ],
  "./_competition/pages/CompetitionTable/index": [
    "69432",
    9,
    "22056",
    "38708",
    "91137"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useShowcaseTexts.ts": [
    "61644",
    9
  ],
  "./_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation": [
    "36014",
    9
  ],
  "./_deziiign/s-fashion/app.tsx": [
    "40127",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "93492"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/vertical_card.svg": [
    "96378",
    1,
    "57159"
  ],
  "./_deziiign/cgrave/routesList": [
    "7524",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54821"
  ],
  "./_deziiign/onlines/pages/readymag/InitPage": [
    "82021",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "98042",
    "32301",
    "67269",
    "53414"
  ],
  "./_deziiign/kiiids/pages/roleAdmin/RoleAdminPage.tsx": [
    "52222",
    9,
    "92275"
  ],
  "./_deziiign/awards/app.tsx": [
    "10445",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "89054"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage": [
    "166",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/CategoryEdit": [
    "38310",
    9
  ],
  "./_deziiign/awards/pages/EmployeesContext/": [
    "31656",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "28689"
  ],
  "./_competition/pages/JuryPage/styles.ts": [
    "80070",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-longread": [
    "55855",
    9,
    "20004"
  ],
  "./_deziiign/books/core/components/designerSearch/styles.tsx": [
    "46609",
    9,
    "97450"
  ],
  "./_deziiign/kiiids/utils/index.ts": [
    "25179",
    9,
    "14824"
  ],
  "./_deziiign/ageytomesh/app.tsx": [
    "61045",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "24822"
  ],
  "./_competition/pages/ShortListPage/ShortListPage.tsx": [
    "37613",
    9
  ],
  "./_deziiign/books/pages/BookEdit/sections/ProtectSection": [
    "80194",
    9
  ],
  "./_deziiign/cgrave/pages/CgRaveJuriesPage.tsx": [
    "55002",
    9,
    "31591"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagPage.tsx": [
    "88716",
    9,
    "3157",
    "61341"
  ],
  "./_deziiign/game/app": [
    "86185",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "49170"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanArrayContentEditField.tsx": [
    "24361",
    9,
    "34418"
  ],
  "./_deziiign/profmediiia/routesList": [
    "10777",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "67810"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionView.tsx": [
    "255",
    9
  ],
  "./_deziiign/hsedesign/app": [
    "66841",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "13779",
    "99554"
  ],
  "./_deziiign/s-software-engineering/routesList.tsx": [
    "45829",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "5318"
  ],
  "./_deziiign/books/helpers/copyLink": [
    "77885",
    9
  ],
  "./_deziiign/naturemediiia/routesList": [
    "93869",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97758"
  ],
  "./_deziiign/onlines/pages/readymag/video/VideoPage": [
    "48580",
    9,
    "1979",
    "13918",
    "63342",
    "74917"
  ],
  "./_deziiign/books/pages/BookEdit/components/CustomInput": [
    "40837",
    9,
    "99142"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/index.tsx": [
    "51397",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "67270"
  ],
  "./_deziiign/books/core/components/bookCard/": [
    "21273",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/types": [
    "94393",
    9
  ],
  "./_deziiign/naturemediiia/app.tsx": [
    "78614",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "51835"
  ],
  "./_competition/pages/AllCompetitionsPage/types": [
    "29334",
    9
  ],
  "./_deziiign/books/pages/BookEdit/": [
    "25525",
    9,
    "44086"
  ],
  "./_deziiign/conceptmediiia/routesList.tsx": [
    "83700",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "62165"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCardList.tsx": [
    "33014",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/EmployeesContext": [
    "51106",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "6879"
  ],
  "./_deziiign/hsespace/utils/": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/lmshsecreative/routesList.tsx": [
    "83811",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "91424"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringContentEditField.tsx": [
    "32449",
    9,
    "50042"
  ],
  "./_deziiign/main/pages/tagAdmin/TagAdminPage.tsx": [
    "44676",
    9,
    "645"
  ],
  "./_deziiign/online/utils": [
    "97367",
    9
  ],
  "./_deziiign/onlines/pages/readymag/turkey/ReadymagPageTR.tsx": [
    "36272",
    9,
    "1979",
    "10314",
    "52393"
  ],
  "./_deziiign/s-psychology/app.tsx": [
    "32336",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31145"
  ],
  "./_deziiign/s-software-engineering/app.tsx": [
    "99790",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "14115"
  ],
  "./_deziiign/school/styles": [
    "6510",
    9,
    "40355"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListWinnerProjectsEdit.tsx": [
    "20260",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCertificatesBlock": [
    "2850",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationThreeReadymag.svg": [
    "6219",
    1,
    "76184"
  ],
  "./_deziiign/onlines/pages/readymag/kz/stylesKZ.ts": [
    "60449",
    9,
    "1979",
    "13918",
    "98042"
  ],
  "./_competition/pages/ProjectsPage/CompetitionInfoPage.tsx": [
    "65548",
    9
  ],
  "./_deziiign/hsehh/styles.tsx": [
    "80446",
    9,
    "78803"
  ],
  "./_competition/pages/AllCompetitionsPage": [
    "60929",
    9,
    "14618"
  ],
  "./_deziiign/onlines/OnlinesMetaTags.tsx": [
    "32482",
    9,
    "42143"
  ],
  "./_deziiign/awards/app": [
    "10445",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "89054"
  ],
  "./_deziiign/books/pages/tag/": [
    "17800",
    9,
    "13908",
    "21655",
    "21565",
    "59761"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionJuryCard": [
    "21919",
    9
  ],
  "./_deziiign/booksgallllery/ExtraPage/index": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/books/core/components/bookCard/bookCard.tsx": [
    "35468",
    9
  ],
  "./_deziiign/s-political-science/routesList": [
    "7938",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "90783"
  ],
  "./_deziiign/lmsmediiia/routesList.tsx": [
    "74328",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54209"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-tags": [
    "22226",
    9,
    "99727"
  ],
  "./_deziiign/s-management/app.tsx": [
    "46822",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "46507"
  ],
  "./_deziiign/s-mathematics/routesList": [
    "82264",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "15905"
  ],
  "./_deziiign/s-urban-development/app.tsx": [
    "69291",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "61528"
  ],
  "./_deziiign/main/pages/tagAdmin/index": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_competition/pages/AllCompetitionsPage/const/hseSpaceCompetitionContexts.ts": [
    "62690",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/calendarReadymag.svg": [
    "8324",
    1,
    "99205"
  ],
  "./_deziiign/kiiids/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "43782",
    9,
    "33355"
  ],
  "./_deziiign/school/utils/index": [
    "89716",
    9,
    "99509"
  ],
  "./_deziiign/books/core/components/designerSearch/styles": [
    "46609",
    9,
    "97450"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ps.svg": [
    "48820",
    1,
    "98453"
  ],
  "./_deziiign/books/pages/sections/ps-image": [
    "9421",
    9
  ],
  "./_competition/pages/PreRegistrationResult/index.ts": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanArrayContentEditField": [
    "24361",
    9,
    "34418"
  ],
  "./_deziiign/books/pages/tag/tagBookListViewLayout.tsx": [
    "85154",
    9,
    "18751"
  ],
  "./_deziiign/books/pages/BookChapterCreate/BookChapterCreate": [
    "52636",
    9,
    "85357"
  ],
  "./_deziiign/hsecreative/routesList": [
    "23307",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "99416"
  ],
  "./_deziiign/awards/styles.tsx": [
    "37460",
    9,
    "98197"
  ],
  "./_deziiign/damuseum/utils/index": [
    "8895",
    9,
    "67156"
  ],
  "./_deziiign/namesmediiia/app.tsx": [
    "47185",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "55402"
  ],
  "./_deziiign/sciencemediiia/app": [
    "65447",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "58028"
  ],
  "./_competition/pages/CreateCompetitionPage/sections/ContextsSections/ContextsSection": [
    "84390",
    9
  ],
  "./_competition/pages/ShortListPage/": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/transfermediiia/app.tsx": [
    "56774",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "70987"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/flag.svg": [
    "58764",
    1,
    "19421"
  ],
  "./_deziiign/s-music/routesList": [
    "10621",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31790"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionContexts": [
    "2696",
    9
  ],
  "./_deziiign/hsespacefilm/routesList": [
    "18438",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "555"
  ],
  "./_deziiign/profmediiia/routesList.tsx": [
    "10777",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "67810"
  ],
  "./_deziiign/s-cinema/app.tsx": [
    "64646",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "363"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useCompetitionsTabs": [
    "70789",
    9
  ],
  "./_competition/components/Image.jpg": [
    "95503",
    1,
    "44676"
  ],
  "./_competition/pages/AllCompetitionsPage/AllCompetitionsPage": [
    "21593",
    9
  ],
  "./_deziiign/school/app": [
    "46931",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44080"
  ],
  "./_deziiign/main/pages/tagAdmin/": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_deziiign/books/core/components/bookCard/index.tsx": [
    "21273",
    9
  ],
  "./_deziiign/cgrave/app.tsx": [
    "48621",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "63934"
  ],
  "./_deziiign/continuumsite/components/ContinuumPage": [
    "43455",
    9,
    "54452"
  ],
  "./_deziiign/artmediiia/app.tsx": [
    "43916",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "6749"
  ],
  "./_deziiign/awards/pages/roleAdmin/RoleAdminPage.tsx": [
    "51697",
    9,
    "73706"
  ],
  "./_deziiign/s-culturology/app.tsx": [
    "9048",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "37729"
  ],
  "./_deziiign/s-pro/app": [
    "45622",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "18651"
  ],
  "./_deziiign/kiiids/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "43782",
    9,
    "33355"
  ],
  "./_deziiign/s-biology/app.tsx": [
    "72594",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "77743"
  ],
  "./_deziiign/books/pages/tag/index.ts": [
    "17800",
    9,
    "13908",
    "21655",
    "21565",
    "59761"
  ],
  "./_deziiign/continuumsite/img/image_744.png": [
    "46966",
    1,
    "57627"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/index": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/foodmediiia/app": [
    "86805",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "59126"
  ],
  "./_deziiign/s-culturology/routesList.tsx": [
    "49467",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "76872"
  ],
  "./_competition/pages/CompetitionResultsPage/index.tsx": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/booksgallllery/routesList.tsx": [
    "14518",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "98363"
  ],
  "./_deziiign/lab/app.tsx": [
    "14678",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44571"
  ],
  "./_deziiign/s-management/app": [
    "46822",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "46507"
  ],
  "./_deziiign/books/pages/sections/ps-buttons.tsx": [
    "94539",
    9,
    "48056"
  ],
  "./_deziiign/artmediiia/routesList": [
    "6743",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "88156"
  ],
  "./_deziiign/adcrdafesnet/const/CGRaveCompetitions": [
    "68",
    9,
    "36069"
  ],
  "./_deziiign/booksgallllery/app.tsx": [
    "76643",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "66688"
  ],
  "./_deziiign/pro/routesList.tsx": [
    "16598",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "46706"
  ],
  "./_deziiign/main/pages/eduTagAdmin/EduTagAdminPage": [
    "97728",
    9,
    "27769"
  ],
  "./_deziiign/main/routesList.tsx": [
    "67087",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "47108"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/styles.ts": [
    "1094",
    9,
    "1979",
    "64171"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/index": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/main/pages/projectDeziign/projectDeziign.tsx": [
    "68537",
    9,
    "19955",
    "61186"
  ],
  "./_deziiign/cgrave/pages/CgRaveNomineesPage": [
    "11278",
    9,
    "8739"
  ],
  "./_deziiign/greenaward/styles.tsx": [
    "52890",
    9,
    "32455"
  ],
  "./_geograffee/academy/routesList": [
    "28768",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "71769"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/FloatingPager": [
    "85524",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/types.ts": [
    "94393",
    9
  ],
  "./_deziiign/hsecreativehub/app.tsx": [
    "44527",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "95620"
  ],
  "./_deziiign/brnd/app.tsx": [
    "8109",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23902"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardTools.tsx": [
    "19117",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/const/hseSpaceCompetitionContexts": [
    "62690",
    9
  ],
  "./_deziiign/continuumsite/components/ContinuumPage.tsx": [
    "43455",
    9,
    "54452"
  ],
  "./_deziiign/s-jurisprudence/app": [
    "87039",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64605"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-longread.tsx": [
    "55855",
    9,
    "20004"
  ],
  "./_geograffee/places/pages/tagPlaces/TagPlacesPage.tsx": [
    "87819",
    9,
    "14488"
  ],
  "./_competition/pages/JuryPage/styles": [
    "80070",
    9
  ],
  "./_geograffee/dafes/app.tsx": [
    "76242",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "37071"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/styles.ts": [
    "18626",
    9,
    "59871"
  ],
  "./_competition/routesList.tsx": [
    "1875",
    9,
    "78074",
    "56496"
  ],
  "./_deziiign/s-computer-science-and-engineering/app.tsx": [
    "24643",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "10720"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Platforms": [
    "59628",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/components/Layout.tsx": [
    "56925",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/index.tsx": [
    "67884",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "11325"
  ],
  "./_deziiign/hsedesign/components/IndexTitle.tsx": [
    "91797",
    9
  ],
  "./_deziiign/game/app.tsx": [
    "86185",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "49170"
  ],
  "./_deziiign/hsespace/components/IndexTitle": [
    "47749",
    9,
    "79686"
  ],
  "./_deziiign/naturemediiia/routesList.tsx": [
    "93869",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97758"
  ],
  "./_deziiign/s-physics/app.tsx": [
    "76764",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "89997"
  ],
  "./_deziiign/onlines/pages/readymag/images/bgReadymag.jpg": [
    "32490",
    1,
    "77559"
  ],
  "./_deziiign/onlines/pages/readymag/english/ReadymagPage.tsx": [
    "43812",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "67269"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionWinnerName": [
    "20936",
    9
  ],
  "./_deziiign/kiiids/routesList.tsx": [
    "85885",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "81038"
  ],
  "./_competition/pages/CreateCompetitionPage/sections/ContextsSections/ContextsSection.tsx": [
    "84390",
    9
  ],
  "./_deziiign/hseanimation/app": [
    "36769",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "25562"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/components/CompetitionModalTabs.tsx": [
    "79982",
    9
  ],
  "./_deziiign/damuseum/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "41914",
    9,
    "64647"
  ],
  "./_deziiign/transfermediiia/app": [
    "56774",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "70987"
  ],
  "./_deziiign/hsedesign/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "53649",
    9,
    "17642"
  ],
  "./_deziiign/s-philosophy/routesList.tsx": [
    "89821",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "8782"
  ],
  "./_deziiign/books/pages/BookEdit/BookEdit": [
    "72536",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/blender.svg": [
    "85533",
    1,
    "97038"
  ],
  "./_deziiign/mediiia/routesList": [
    "24864",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "45497"
  ],
  "./_deziiign/s-sociology/routesList.tsx": [
    "82256",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "26089"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/TLandContentEditField": [
    "96241",
    9,
    "80298"
  ],
  "./_deziiign/books/core/components/shareButton": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star2.svg": [
    "57359",
    1,
    "54532"
  ],
  "./_deziiign/profmediiia/app": [
    "18186",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "51031"
  ],
  "./_deziiign/hsespacefilm/app": [
    "32499",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "38256"
  ],
  "./_deziiign/urbanmediiia/routesList": [
    "31300",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "58533"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/LibBrandingPage": [
    "14885",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "58566"
  ],
  "./_deziiign/main/pages/moderHseView": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/hsespacecreative/routesList.tsx": [
    "9137",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "27402"
  ],
  "./_deziiign/main/pages/moderView": [
    "15597",
    9,
    "51382",
    "70494"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/styles": [
    "21768",
    9,
    "89105"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/styles.ts": [
    "21768",
    9,
    "89105"
  ],
  "./_deziiign/damuseum/components/IndexTitle": [
    "42702",
    9,
    "52483"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/": [
    "67884",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "11325"
  ],
  "./_deziiign/creativemediiia/app.tsx": [
    "38719",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86621"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionEditPlus": [
    "89004",
    9,
    "52701"
  ],
  "./_competition/pages/CompetitionResultsPage/CompetitionResultsPage.tsx": [
    "10235",
    9,
    "22056"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookImageContainer": [
    "29312",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/styles.css": [
    "30922",
    9
  ],
  "./_deziiign/onlines/app.tsx": [
    "29095",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "13836"
  ],
  "./_deziiign/main/pages/eduTagAdmin/": [
    "25672",
    9,
    "27769",
    "32049"
  ],
  "./_deziiign/awards/utils/index": [
    "97022",
    9,
    "7539"
  ],
  "./_deziiign/kiiids/components/IndexTitle.tsx": [
    "58818",
    9,
    "53023"
  ],
  "./_competition/components/CompetitionFormStart.tsx": [
    "53915",
    9,
    "80328"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/resultitem": [
    "1746",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/EmployeesContext.tsx": [
    "51106",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "6879"
  ],
  "./_deziiign/s-economy/app.tsx": [
    "30587",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "69032"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/DesktopReadymag.svg": [
    "11811",
    1,
    "51200"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/styles.ts": [
    "63011",
    9
  ],
  "./_deziiign/main/app.tsx": [
    "71236",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "47108",
    "20069"
  ],
  "./_competition/const.ts": [
    "19408",
    9
  ],
  "./_deziiign/books/core/components/error-frames/book-edit-frames": [
    "88358",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/": [
    "40565",
    9,
    "23126"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/OptionContentEditField": [
    "70009",
    9,
    "30818"
  ],
  "./_deziiign/s-jurisprudence/routesList.tsx": [
    "35639",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "85500"
  ],
  "./_deziiign/s-music/routesList.tsx": [
    "10621",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31790"
  ],
  "./_geograffee/main/routesList": [
    "29087",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "18900"
  ],
  "./_deziiign/s-arthistory/routesList": [
    "7121",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "87306"
  ],
  "./_deziiign/books/core/components/error-frames/book-edit-frames.tsx": [
    "88358",
    9
  ],
  "./_deziiign/awards/utils": [
    "97022",
    9,
    "7539"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionCard.tsx": [
    "76742",
    9
  ],
  "./_deziiign/books/pages/BookListView/BookListView.tsx": [
    "85406",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "96979"
  ],
  "./_deziiign/main/pages/moderView/ProjectTilesMapDeziiign.tsx": [
    "16148",
    9,
    "44821"
  ],
  "./_deziiign/damuseum/components/IndexTitle.tsx": [
    "42702",
    9,
    "52483"
  ],
  "./_deziiign/hsecolors/styles": [
    "9186",
    9,
    "86719"
  ],
  "./_deziiign/hsehh/styles": [
    "80446",
    9,
    "78803"
  ],
  "./_deziiign/damuseum/styles": [
    "32402",
    9,
    "67110"
  ],
  "./_deziiign/main/pages/moderHseView/moderHseView": [
    "53627",
    9,
    "99272"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagEdit.tsx": [
    "441",
    9,
    "70530"
  ],
  "./_deziiign/fashionmediiia/routesList": [
    "77396",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "7477"
  ],
  "./_deziiign/onlines/pages/readymag/video/styles": [
    "48516",
    9,
    "73637"
  ],
  "./_deziiign/musicmediiia/app.tsx": [
    "62630",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "58923"
  ],
  "./_deziiign/hsecolors/styles.tsx": [
    "9186",
    9,
    "86719"
  ],
  "./_deziiign/superpuper/routesList": [
    "76673",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23130"
  ],
  "./_competition/pages/JuryPage": [
    "5122",
    9,
    "91967"
  ],
  "./_deziiign/s-architect/routesList.tsx": [
    "52833",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "74394"
  ],
  "./_deziiign/cgrave/routesList.tsx": [
    "7524",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54821"
  ],
  "./_deziiign/books/core/components/datePickerRange/styles.ts": [
    "63545",
    9,
    "82850"
  ],
  "./_deziiign/s-psychology/routesList.tsx": [
    "81139",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "25680"
  ],
  "./_competition/pages/ProjectsPage": [
    "31708",
    9,
    "99309"
  ],
  "./_deziiign/eventmediiia/app.tsx": [
    "98329",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5890"
  ],
  "./_deziiign/hseanimation/app.tsx": [
    "36769",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "25562"
  ],
  "./_deziiign/hseanimation/routesList": [
    "27072",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "55417"
  ],
  "./_deziiign/main/pages/tagAdmin/TagAdminPage": [
    "44676",
    9,
    "645"
  ],
  "./_deziiign/lmshsecreative/app": [
    "59520",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64665"
  ],
  "./_deziiign/s-philology/routesList.tsx": [
    "22217",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "1490"
  ],
  "./_deziiign/aimediiia/app": [
    "49867",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31576"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext/": [
    "4817",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "49674"
  ],
  "./_deziiign/books/pages/BookEdit/components/CustomInput.tsx": [
    "40837",
    9,
    "99142"
  ],
  "./_deziiign/s-culturology/app": [
    "9048",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "37729"
  ],
  "./_deziiign/lmshsecreative/routesList": [
    "83811",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "91424"
  ],
  "./_deziiign/awards/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "56581",
    9,
    "16646"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/map.tsx": [
    "72684",
    9,
    "6602",
    "96678",
    "52477"
  ],
  "./_competition/pages/AllOpenCalls": [
    "62910",
    9,
    "2003"
  ],
  "./_deziiign/eventmediiia/routesList.tsx": [
    "4152",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "79073"
  ],
  "./_competition/pages/EmptyPage.tsx": [
    "90798",
    9,
    "81251"
  ],
  "./_deziiign/lmshse/app.tsx": [
    "59755",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "7512"
  ],
  "./_deziiign/main/pages/MainTagAdminPage": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-authorDeziign": [
    "13598",
    9,
    "72339"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "95636",
    9,
    "35499",
    "28821"
  ],
  "./_deziiign/books/core/components/booksSearchBar/style.ts": [
    "17998",
    9,
    "56067"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/assets/prev.svg": [
    "89819",
    1,
    "59528"
  ],
  "./_deziiign/school/utils": [
    "89716",
    9,
    "99509"
  ],
  "./_deziiign/dvadesign/app.tsx": [
    "31062",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "86843"
  ],
  "./_deziiign/main/pages/eduTagAdmin": [
    "25672",
    9,
    "27769",
    "32049"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/OpenDay.tsx": [
    "69568",
    9,
    "6153",
    "1979",
    "64171",
    "93081"
  ],
  "./_deziiign/books/core/hook/api/useBook.ts": [
    "97393",
    9,
    "75882"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/styles.ts": [
    "73222",
    9
  ],
  "./_competition/pages/SeasonEdit/SeasonEditPage.tsx": [
    "94292",
    9,
    "78037"
  ],
  "./_deziiign/urbanmediiia/routesList.tsx": [
    "31300",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "58533"
  ],
  "./_deziiign/hsedesign/utils/": [
    "46106",
    9
  ],
  "./_deziiign/fashion/app.tsx": [
    "979",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71856"
  ],
  "./_deziiign/books/core/components/tooltips/index": [
    "40356",
    9
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64979;
module.exports = webpackAsyncContext;
var map = {
  "./_deziiign/s-jurisprudence/routesList": [
    "35639",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "85500"
  ],
  "./_deziiign/lpudesign/styles": [
    "72095",
    9,
    "29364"
  ],
  "./_deziiign/adcrdafesnet/app": [
    "72893",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "68398"
  ],
  "./_deziiign/main/pages/moderView/index.ts": [
    "15597",
    9,
    "51382",
    "70494"
  ],
  "./_deziiign/books/core/components/grid": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/onlines/pages/readymag/english/styles.ts": [
    "45149",
    9,
    "1979",
    "13918",
    "63342"
  ],
  "./_deziiign/books/core/components/datePickerRange/DatePickerRange.tsx": [
    "30204",
    9,
    "13908",
    "39757"
  ],
  "./_deziiign/s-geography/routesList.tsx": [
    "10596",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97093"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCertificatesBlock.tsx": [
    "2850",
    9
  ],
  "./_deziiign/books/pages/tag/index": [
    "17800",
    9,
    "13908",
    "21655",
    "21565",
    "59761"
  ],
  "./_deziiign/onlines/pages/readymag/library/styles": [
    "33756",
    9,
    "94253"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/styles.ts": [
    "86409",
    9,
    "94930"
  ],
  "./_deziiign/sportmediiia/app": [
    "37223",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "4076"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout.tsx": [
    "99082",
    9
  ],
  "./_deziiign/main/pages/tagAdmin": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_deziiign/s-urban-development/routesList.tsx": [
    "14622",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "14419"
  ],
  "./_deziiign/damuseum/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "62023",
    9,
    "35499",
    "96716"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/TagsTypeSwitcher.tsx": [
    "51152",
    9
  ],
  "./_geograffee/dafes/pages/CountryShowcase": [
    "62779",
    9,
    "15969",
    "35974",
    "24092"
  ],
  "./_deziiign/books/pages/BookView/components/BookHeader": [
    "6371",
    9,
    "95360"
  ],
  "./_deziiign/booksmediiia/routesList": [
    "69210",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44807"
  ],
  "./_deziiign/continuumsite/img/image_1440.png": [
    "58626",
    1,
    "3167"
  ],
  "./_deziiign/hsecreative/styles": [
    "41431",
    9,
    "7036"
  ],
  "./_deziiign/historymediiia/app": [
    "70761",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "49970"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagAdd.tsx": [
    "34484",
    9,
    "3157"
  ],
  "./_deziiign/books/pages/sections/ps-chapters.tsx": [
    "10434",
    9
  ],
  "./_deziiign/s-mathematics/app": [
    "63417",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "3138"
  ],
  "./_competition/pages/PreRegistrationResult": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/hsehh/app.tsx": [
    "3651",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "94624"
  ],
  "./_deziiign/books/core/components/template/book-container-layout.styles": [
    "5703",
    9,
    "1877"
  ],
  "./_deziiign/onlines/routesList": [
    "68354",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6047"
  ],
  "./_deziiign/main/pages/moderHseView/ProjectTilesMapDeziiign.tsx": [
    "61848",
    9,
    "45825"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/styles.ts": [
    "93487",
    9,
    "77316"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationTwo.svg": [
    "53123",
    1,
    "28832"
  ],
  "./_deziiign/books/core/components/tooltips/BookTooltip.tsx": [
    "67816",
    9
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout.css": [
    "86691",
    9,
    "63008"
  ],
  "./_geograffee/dafes/pages/CountryShowcase.tsx": [
    "62779",
    9,
    "15969",
    "35974",
    "24092"
  ],
  "./_deziiign/hsestart/styles.tsx": [
    "69730",
    9,
    "59551"
  ],
  "./_competition/pages/AllCompetitionsPage/competitionTagsCloud.tsx": [
    "40443",
    9
  ],
  "./_deziiign/monalisatravels/routesList.tsx": [
    "58745",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "93410"
  ],
  "./_deziiign/historymediiia/routesList": [
    "93384",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "24881"
  ],
  "./_competition/components/CompetitionTellingStoriesPreview.tsx": [
    "29619",
    9,
    "13456"
  ],
  "./_deziiign/continuumsite/img/image_320.png": [
    "76496",
    1,
    "92841"
  ],
  "./_deziiign/main/pages/projectDeziign/styles.tsx": [
    "16478",
    9,
    "13043"
  ],
  "./_deziiign/greenaward/components/IndexTitle": [
    "69371",
    9,
    "88360"
  ],
  "./_deziiign/books/pages/BookEdit/sections/ProtectSection.tsx": [
    "80194",
    9
  ],
  "./_deziiign/s-public-administration/routesList.tsx": [
    "96916",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "51125"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useShowcaseTexts": [
    "61644",
    9
  ],
  "./_deziiign/ageytomesh/routesList": [
    "92044",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "67741"
  ],
  "./_deziiign/storiesmediiia/routesList.tsx": [
    "88515",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "20800"
  ],
  "./_deziiign/damuseum/app": [
    "70666",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "12439"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/flagtop.svg": [
    "57053",
    1,
    "56942"
  ],
  "./_deziiign/fashion/app": [
    "979",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71856"
  ],
  "./_deziiign/s-political-science/routesList.tsx": [
    "7938",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "90783"
  ],
  "./_deziiign/s-cinema/routesList": [
    "18301",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "5262"
  ],
  "./_competition/pages/AllCompetitionsPage/AllCompetitionsPage.tsx": [
    "21593",
    9
  ],
  "./_competition/pages/CompetitionResultsPage/index": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/NumberContentEditField": [
    "34897",
    9,
    "40266"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/OpenDay": [
    "69568",
    9,
    "6153",
    "1979",
    "64171",
    "93081"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionAutomaticPage.tsx": [
    "8078",
    9,
    "53283"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBarLayout": [
    "80714",
    9,
    "51735"
  ],
  "./_deziiign/designmediiia/app": [
    "72483",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "25760"
  ],
  "./_deziiign/books/core/book-delegate.ts": [
    "88325",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/": [
    "60929",
    9,
    "14618"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardTools": [
    "19117",
    9
  ],
  "./_deziiign/lab/routesList.tsx": [
    "59821",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "68990"
  ],
  "./_deziiign/online/styles": [
    "10509",
    9,
    "50718"
  ],
  "./_deziiign/main/pages/projectDeziign/projectDeziign": [
    "68537",
    9,
    "19955",
    "61186"
  ],
  "./_deziiign/aimediiia/routesList.tsx": [
    "83870",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "42291"
  ],
  "./_competition/pages/CompetitionResultsPage": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/kiiids/components/IndexTitle": [
    "58818",
    9,
    "53023"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionWinnerName.tsx": [
    "20936",
    9
  ],
  "./_deziiign/books/core/components/shareButton/index.ts": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/TLandContentEditField.tsx": [
    "96241",
    9,
    "80298"
  ],
  "./_deziiign/main/pages/moderHseView/index.ts": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/kiiids/routesList": [
    "85885",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "81038"
  ],
  "./_deziiign/onlines/pages/readymag/library/styles.ts": [
    "33756",
    9,
    "94253"
  ],
  "./_deziiign/school/routesList": [
    "262",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "87723"
  ],
  "./_deziiign/cinemediiia/app": [
    "27588",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50533"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveJuriesPage": [
    "22570",
    9,
    "83863"
  ],
  "./_deziiign/books/core/components/tooltips/": [
    "40356",
    9
  ],
  "./_deziiign/hsedesign/pages/StatisticsPage/StatisticsPage": [
    "32042",
    9,
    "13908",
    "26324",
    "10039"
  ],
  "./_deziiign/s-history/routesList.tsx": [
    "74294",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "58971"
  ],
  "./_deziiign/s-oriental/routesList.tsx": [
    "27850",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "9367"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookImageContainer.tsx": [
    "29312",
    9
  ],
  "./_deziiign/greenaward/utils": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/books/core/hook/api/useBookList.ts": [
    "72617",
    9,
    "96850"
  ],
  "./_deziiign/s-international-relations/routesList.tsx": [
    "48390",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "99627"
  ],
  "./_deziiign/onlines/routesList.tsx": [
    "68354",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6047"
  ],
  "./_deziiign/onlines/pages/readymag/video/VideoPage.tsx": [
    "48580",
    9,
    "1979",
    "13918",
    "63342",
    "74917"
  ],
  "./_deziiign/hsecreative/styles.tsx": [
    "41431",
    9,
    "7036"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/reducer/reducer": [
    "68649",
    9,
    "41906"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/blocks.svg": [
    "75650",
    1,
    "84127"
  ],
  "./_deziiign/books/pages/BookListView/BookListViewInner": [
    "8700",
    9,
    "13908",
    "21655",
    "21565",
    "5357"
  ],
  "./_deziiign/s-philosophy/routesList": [
    "89821",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "8782"
  ],
  "./_deziiign/books/pages/sections/assets/link.svg": [
    "12118",
    1,
    "187"
  ],
  "./_deziiign/books/pages/tag": [
    "17800",
    9,
    "13908",
    "21655",
    "21565",
    "59761"
  ],
  "./_deziiign/main/pages/eduTagAdmin/index.ts": [
    "25672",
    9,
    "27769",
    "32049"
  ],
  "./_deziiign/automediiia/routesList.tsx": [
    "83561",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54130"
  ],
  "./_deziiign/main/styles": [
    "94163",
    9,
    "28592"
  ],
  "./_deziiign/namesmediiia/app": [
    "47185",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "55402"
  ],
  "./_deziiign/artmediiia/app": [
    "43916",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "6749"
  ],
  "./_deziiign/automediiia/routesList": [
    "83561",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54130"
  ],
  "./_deziiign/s-arthistory/routesList.tsx": [
    "7121",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "87306"
  ],
  "./_deziiign/books/pages/BookChapterCreate/index": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/photomediiia/routesList": [
    "81564",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "41901"
  ],
  "./_geograffee/academy/app": [
    "47617",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5370"
  ],
  "./_deziiign/books/core/components/controllers/BooksButchController.tsx": [
    "90929",
    9,
    "68778"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanContentEditField": [
    "38958",
    9,
    "43907"
  ],
  "./_competition/pages/ShortListPage/assets/LaurelWreathRight.svg": [
    "31052",
    1,
    "34813"
  ],
  "./_deziiign/books/core/components/shareButton/": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/creativemediiia/app": [
    "38719",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86621"
  ],
  "./_deziiign/s-economy/routesList.tsx": [
    "59950",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "8771"
  ],
  "./_deziiign/onlines/pages/readymag/kz/ReadymagPageKZ.tsx": [
    "45660",
    9,
    "1979",
    "13918",
    "42722",
    "98042",
    "32301"
  ],
  "./_deziiign/books/pages/BookListView/BookListViewInner.tsx": [
    "8700",
    9,
    "13908",
    "21655",
    "21565",
    "5357"
  ],
  "./_deziiign/urbanmediiia/app": [
    "22093",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5214"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/wib1.jpg": [
    "20821",
    1,
    "91606"
  ],
  "./_deziiign/books/core/hook/api/useBook": [
    "97393",
    9,
    "75882"
  ],
  "./_deziiign/superpuper/styles.tsx": [
    "45757",
    9,
    "16398"
  ],
  "./_competition/components/CompetitionFormStart": [
    "53915",
    9,
    "80328"
  ],
  "./_competition/components/style": [
    "10301",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateBriefCompetition.tsx": [
    "94880",
    9,
    "17433"
  ],
  "./_deziiign/main/pages/tagAdmin/index.ts": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_deziiign/brnd/routesList": [
    "59684",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21733"
  ],
  "./_deziiign/kiiids/app": [
    "43814",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5227"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/index": [
    "67884",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "11325"
  ],
  "./_deziiign/lpudesign/routesList": [
    "56163",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "42368"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/index": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/hsedesign/styles": [
    "91408",
    9,
    "49545"
  ],
  "./_deziiign/hsespace/components/IndexTitle.tsx": [
    "47749",
    9,
    "79686"
  ],
  "./_deziiign/books/pages/BookEdit/sections/styles": [
    "14954",
    9
  ],
  "./_deziiign/books/pages/BookView/components/MainBookTitle": [
    "53341",
    9
  ],
  "./_deziiign/s-cinema/routesList.tsx": [
    "18301",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "5262"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext": [
    "4817",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "49674"
  ],
  "./_deziiign/automediiia/app": [
    "38106",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "99687"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/CombatEntitiesContentEditField": [
    "40683",
    9,
    "38776"
  ],
  "./_deziiign/cinemediiia/routesList.tsx": [
    "91311",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "81188"
  ],
  "./_deziiign/hsedesign/utils/index.ts": [
    "46106",
    9
  ],
  "./_deziiign/kiiids/pages/EmployeesModerContext/EmployeesModerContext": [
    "16179",
    9,
    "35499",
    "1680"
  ],
  "./_deziiign/books/pages/BookChapterCreate/": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/books/pages/sections/ps-chapters": [
    "10434",
    9
  ],
  "./_deziiign/main/routesList": [
    "67087",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "47108"
  ],
  "./_deziiign/onlines/OnlinesMetaTags": [
    "32482",
    9,
    "42143"
  ],
  "./_geograffee/hsealumni/app": [
    "78689",
    9,
    "83762",
    "50323",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "97775",
    "92287",
    "71237",
    "9452",
    "66673",
    "35499",
    "59037",
    "59017",
    "60204",
    "73645",
    "27354"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCardList": [
    "33014",
    9
  ],
  "./_deziiign/main/pages/projectDeziign": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/search.svg": [
    "93686",
    1,
    "51163"
  ],
  "./_deziiign/continuumsite/routesList.tsx": [
    "97765",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6886"
  ],
  "./_deziiign/iqmedia/routesList": [
    "70364",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "96525"
  ],
  "./_deziiign/photomediiia/routesList.tsx": [
    "81564",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "41901"
  ],
  "./_deziiign/s-oriental/routesList": [
    "27850",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "9367"
  ],
  "./_deziiign/s-biology/routesList.tsx": [
    "28257",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "73402"
  ],
  "./_deziiign/onlines/styles.tsx": [
    "50450",
    9,
    "73359"
  ],
  "./_deziiign/books/app": [
    "52905",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64585"
  ],
  "./_deziiign/musicmediiia/routesList.tsx": [
    "17469",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23406"
  ],
  "./_deziiign/onlines/pages/readymag/InitPage.tsx": [
    "82021",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "98042",
    "32301",
    "67269",
    "53414"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/styles": [
    "18626",
    9,
    "59871"
  ],
  "./_deziiign/cgrave/app": [
    "48621",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "63934"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Categories": [
    "93506",
    9
  ],
  "./_competition/components/SendProjectButton.tsx": [
    "26709",
    9
  ],
  "./_deziiign/s-history/app": [
    "25571",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83552"
  ],
  "./_deziiign/books/pages/BookEdit/styles": [
    "5171",
    9
  ],
  "./_deziiign/historymediiia/app.tsx": [
    "70761",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "49970"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/NumberContentEditField.tsx": [
    "34897",
    9,
    "40266"
  ],
  "./_deziiign/books/pages/BookEdit": [
    "25525",
    9,
    "44086"
  ],
  "./_deziiign/onlines/pages/readymag/english/ReadymagPage": [
    "43812",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "67269"
  ],
  "./_deziiign/books/pages/BookListView/": [
    "76584",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/pro/app": [
    "31834",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "43559"
  ],
  "./_deziiign/s-philosophy/app": [
    "9222",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50155"
  ],
  "./_deziiign/s-psychology/routesList": [
    "81139",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "25680"
  ],
  "./_deziiign/s-public-administration/app.tsx": [
    "21533",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "39662"
  ],
  "./_deziiign/books/pages/BookListView/BookListView": [
    "85406",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "96979"
  ],
  "./_competition/pages/JuryPage/index.ts": [
    "5122",
    9,
    "91967"
  ],
  "./_deziiign/galllleryart/routesList.tsx": [
    "43137",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "93914"
  ],
  "./_deziiign/hsecolors/app": [
    "19735",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "43452"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/ButtonEditField.tsx": [
    "95331",
    9,
    "46560"
  ],
  "./_deziiign/ageytomesh/app": [
    "61045",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "24822"
  ],
  "./_deziiign/booksmediiia/app.tsx": [
    "25247",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71668"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext/EmployeesContext.tsx": [
    "32497",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "32522"
  ],
  "./_competition/pages/JuryPage/CompetitionJuryPage": [
    "14449",
    9
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookChaptersEdit.tsx": [
    "58466",
    9
  ],
  "./_deziiign/books/core/components/tooltips/BookTooltip": [
    "67816",
    9
  ],
  "./_deziiign/awards/components/IndexTitle": [
    "81233",
    9,
    "96362"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/index.ts": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/lmshse/routesList": [
    "89406",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21267"
  ],
  "./_deziiign/dvadesign/routesList": [
    "13069",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "53918"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveNomineesPage": [
    "69662",
    9,
    "65235"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/MobileGlow.svg": [
    "27318",
    1,
    "74203"
  ],
  "./_deziiign/s-hsetto/routesList": [
    "54479",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "25668"
  ],
  "./_deziiign/damuseum/app.tsx": [
    "70666",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "12439"
  ],
  "./_deziiign/hsestart/routesList": [
    "94962",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "63279"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateBriefCompetition": [
    "94880",
    9,
    "17433"
  ],
  "./_deziiign/adcrdafesnet/const/CGRaveCompetitions.ts": [
    "68",
    9,
    "36069"
  ],
  "./_deziiign/artmediiia/routesList.tsx": [
    "6743",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "88156"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext/index.tsx": [
    "4817",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "49674"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/index": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagAdd": [
    "34484",
    9,
    "3157"
  ],
  "./_deziiign/s-pro/app.tsx": [
    "45622",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "18651"
  ],
  "./_deziiign/damuseum/pages/roleAdmin/RoleAdminPage": [
    "16914",
    9,
    "99567"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/searchresults": [
    "77349",
    9,
    "96678"
  ],
  "./_deziiign/kiiids/styles": [
    "19025",
    9,
    "99402"
  ],
  "./_deziiign/hsedesign/pages/roleAdmin/RoleAdminPage.tsx": [
    "2925",
    9,
    "99358"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/styles.ts": [
    "18476",
    9
  ],
  "./_deziiign/prohse/app": [
    "9256",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23313"
  ],
  "./_deziiign/cgrave/const/CGRaveCompetitions": [
    "97044",
    9,
    "15765"
  ],
  "./_deziiign/hseanimation/styles": [
    "37256",
    9,
    "38641"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArray2ContentEditField": [
    "81290",
    9,
    "55863"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustratonFour.svg": [
    "2724",
    1,
    "96069"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter": [
    "60313",
    9,
    "79298"
  ],
  "./_deziiign/photomediiia/app.tsx": [
    "6213",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5478"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListWinnerProjectsEdit": [
    "20260",
    9
  ],
  "./_deziiign/galllleryart/styles.ts": [
    "78199",
    9,
    "52700"
  ],
  "./_deziiign/books/core/components/designerSearch/DesignerSearch.tsx": [
    "10268",
    9,
    "21655",
    "42029"
  ],
  "./_deziiign/aimediiia/app.tsx": [
    "49867",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31576"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCards": [
    "70067",
    9
  ],
  "./_deziiign/profmediiia/app.tsx": [
    "18186",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "51031"
  ],
  "./_deziiign/school/pages/init.tsx": [
    "74957",
    9,
    "48382"
  ],
  "./_geograffee/__COMMON__/commonRoutes.tsx": [
    "68540",
    9,
    "13908",
    "24092",
    "21655",
    "35499",
    "22056",
    "21565",
    "40106",
    "5357",
    "59017",
    "23312",
    "52621"
  ],
  "./_geograffee/dafes/routesList.tsx": [
    "58305",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "43290"
  ],
  "./_competition/pages/JuryPage/index": [
    "5122",
    9,
    "91967"
  ],
  "./_deziiign/designmediiia/app.tsx": [
    "72483",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "25760"
  ],
  "./_deziiign/mediiia/routesList.tsx": [
    "24864",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "45497"
  ],
  "./_deziiign/books/pages/sections/ps-image.tsx": [
    "9421",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-title.tsx": [
    "35075",
    9,
    "95008"
  ],
  "./_deziiign/hsecreativehub/routesList.tsx": [
    "71242",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "57303"
  ],
  "./_competition/pages/CreateCompetitionPage/index.tsx": [
    "40565",
    9,
    "23126"
  ],
  "./_deziiign/books/pages/BookEdit/BookEdit.tsx": [
    "72536",
    9
  ],
  "./_deziiign/main/pages/moderView/ProjectTilesMapDeziiign": [
    "16148",
    9,
    "44821"
  ],
  "./_deziiign/conceptmediiia/routesList": [
    "83700",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "62165"
  ],
  "./_competition/pages/SeasonEdit/SeasonEditPage": [
    "94292",
    9,
    "78037"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-bottom.tsx": [
    "84958",
    9,
    "19955"
  ],
  "./_deziiign/s-media/routesList.tsx": [
    "88674",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "89023"
  ],
  "./_deziiign/onlines/pages/readymag/images/bg2Readymag.jpg": [
    "54970",
    1,
    "32487"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanContentEditField.tsx": [
    "38958",
    9,
    "43907"
  ],
  "./_deziiign/school/utils/": [
    "89716",
    9,
    "99509"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagEdit": [
    "441",
    9,
    "70530"
  ],
  "./_deziiign/awards/pages/EmployeesContext/EmployeesContext": [
    "59929",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "56043"
  ],
  "./_competition/pages/ProjectsPage/": [
    "31708",
    9,
    "99309"
  ],
  "./_deziiign/main/pages/projectDeziign/index.tsx": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_geograffee/__COMMON__/commonRoutes": [
    "68540",
    9,
    "13908",
    "24092",
    "21655",
    "35499",
    "22056",
    "21565",
    "40106",
    "5357",
    "59017",
    "23312",
    "52621"
  ],
  "./_competition/pages/AllCompetitionsPage/styled": [
    "70740",
    9
  ],
  "./_competition/pages/JuryPage/CompetitionJuryPage.tsx": [
    "14449",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationFive.svg": [
    "66863",
    1,
    "13892"
  ],
  "./_deziiign/cgrave/styles.ts": [
    "1380",
    9,
    "5093"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCards.tsx": [
    "70067",
    9
  ],
  "./_deziiign/adcrdafesnet/styles.ts": [
    "14100",
    9,
    "25653"
  ],
  "./_deziiign/kiiids/utils/index": [
    "25179",
    9,
    "14824"
  ],
  "./_deziiign/kiiids/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "16179",
    9,
    "35499",
    "1680"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/resultitem.tsx": [
    "1746",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/components/ProjectImage.tsx": [
    "77159",
    9,
    "6636"
  ],
  "./_deziiign/s-hsetto/routesList.tsx": [
    "54479",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "25668"
  ],
  "./_deziiign/onlines/styles": [
    "50450",
    9,
    "73359"
  ],
  "./_deziiign/cgrave/pages/CgRaveJuriesPage": [
    "55002",
    9,
    "31591"
  ],
  "./_deziiign/damuseum/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "41914",
    9,
    "64647"
  ],
  "./_deziiign/hsecolors/routesList.tsx": [
    "54706",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "40751"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/components/CompetitionModalTabs": [
    "79982",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/eligibility.svg": [
    "41699",
    1,
    "65120"
  ],
  "./_deziiign/s-fashion/routesList": [
    "7386",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "80679"
  ],
  "./_deziiign/automediiia/app.tsx": [
    "38106",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "99687"
  ],
  "./_competition/pages/AllCompetitionsPage/sections/section-cgrave.tsx": [
    "10954",
    9,
    "2967"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardLayout": [
    "99082",
    9
  ],
  "./_competition/pages/CompetitionTable": [
    "69432",
    9,
    "22056",
    "38708",
    "91137"
  ],
  "./_deziiign/books/pages/BookChapterCreate/BookChapterCreate.tsx": [
    "52636",
    9,
    "85357"
  ],
  "./_deziiign/hsecreativehub/app": [
    "44527",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "95620"
  ],
  "./_deziiign/awards/utils/index.ts": [
    "97022",
    9,
    "7539"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/ButtonEditField": [
    "95331",
    9,
    "46560"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringContentEditField": [
    "32449",
    9,
    "50042"
  ],
  "./_deziiign/books/pages/BookView/components/BookTools": [
    "67079",
    9,
    "2325"
  ],
  "./_deziiign/continuumsite/styles.ts": [
    "5915",
    9,
    "9064"
  ],
  "./_deziiign/kiiids/utils": [
    "25179",
    9,
    "14824"
  ],
  "./_deziiign/lmshse/styles": [
    "98454",
    9,
    "4731"
  ],
  "./_deziiign/s-management/routesList": [
    "86269",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35054"
  ],
  "./_deziiign/main/pages/moderView/moderView": [
    "29397",
    9,
    "51382"
  ],
  "./_deziiign/storiesmediiia/routesList": [
    "88515",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "20800"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionCard": [
    "76742",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionAutomaticPage": [
    "8078",
    9,
    "53283"
  ],
  "./_deziiign/game/routesList": [
    "71368",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "75345"
  ],
  "./_deziiign/books/core/components/shareButton/index": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/books/core/components/designerSearch/designerSearchAuth": [
    "3978",
    9,
    "21655"
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/competitionUtils": [
    "22125",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/question.svg": [
    "39708",
    1,
    "19053"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/plus.svg": [
    "13427",
    1,
    "58928"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/whatsapp.svg": [
    "12962",
    1,
    "33567"
  ],
  "./_deziiign/books/core/components/helper/bookEvents": [
    "97590",
    9,
    "73051"
  ],
  "./_deziiign/main/pages/moderView/index": [
    "15597",
    9,
    "51382",
    "70494"
  ],
  "./_deziiign/booksgallllery/ExtraPage": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/main/pages/projectDeziign/index": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_competition/helpers/getDaysToFinish.ts": [
    "20572",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useCompetitionsTabs.tsx": [
    "70789",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/hand.png": [
    "45275",
    1,
    "66472"
  ],
  "./_deziiign/lmshse/styles.tsx": [
    "98454",
    9,
    "4731"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionGrid.tsx": [
    "1268",
    9
  ],
  "./_deziiign/hseanimation/styles.tsx": [
    "37256",
    9,
    "38641"
  ],
  "./_competition/pages/AllCompetitionsPage/helpers/competitionUtils.ts": [
    "22125",
    9
  ],
  "./_deziiign/hsespacefilm/app.tsx": [
    "32499",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "38256"
  ],
  "./_deziiign/superpuper/styles": [
    "45757",
    9,
    "16398"
  ],
  "./_deziiign/kiiids/app.tsx": [
    "43814",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5227"
  ],
  "./_deziiign/greenaward/utils/index": [
    "96912",
    9,
    "94249"
  ],
  "./_geograffee/academy/app.tsx": [
    "47617",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5370"
  ],
  "./_deziiign/main/pages/admin/AdminPage": [
    "63176",
    9,
    "79665"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookPlusIcon.tsx": [
    "37305",
    9
  ],
  "./_deziiign/books/core/components/datePickerRange/DatePickerRange": [
    "30204",
    9,
    "13908",
    "39757"
  ],
  "./_deziiign/foodmediiia/routesList.tsx": [
    "62124",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "53245"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/wib2.jpg": [
    "69834",
    1,
    "86007"
  ],
  "./_deziiign/s-cinema/app": [
    "64646",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "363"
  ],
  "./_deziiign/s-arthistory/app.tsx": [
    "56821",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "28927"
  ],
  "./_deziiign/s-geography/app": [
    "84909",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "12670"
  ],
  "./_deziiign/transfermediiia/routesList": [
    "24253",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "88494"
  ],
  "./_deziiign/pro/routesList": [
    "16598",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "46706"
  ],
  "./_deziiign/school/utils/index.ts": [
    "89716",
    9,
    "99509"
  ],
  "./_competition/pages/AllCompetitionsPage/index.tsx": [
    "60929",
    9,
    "14618"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/components/Layout": [
    "56925",
    9
  ],
  "./_deziiign/adcrdafesnet/routesList": [
    "84852",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "39797"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionPage": [
    "18314",
    9
  ],
  "./_competition/components/CompetitionTellingStoriesPreview": [
    "29619",
    9,
    "13456"
  ],
  "./_deziiign/adcrdafesnet/styles": [
    "14100",
    9,
    "25653"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBar": [
    "89260",
    9,
    "13908",
    "21655",
    "21565"
  ],
  "./_deziiign/monalisatravels/app.tsx": [
    "23293",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "77655"
  ],
  "./_deziiign/s-physics/routesList": [
    "36487",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "39212"
  ],
  "./_deziiign/transfermediiia/routesList.tsx": [
    "24253",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "88494"
  ],
  "./_competition/components/TellingStoriesSuccess": [
    "43479",
    9,
    "10684"
  ],
  "./_deziiign/onlines/pages/readymag/english/styles": [
    "45149",
    9,
    "1979",
    "13918",
    "63342"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/LibBrandingPage.tsx": [
    "14885",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "58566"
  ],
  "./_deziiign/main/pages/moderHseView/": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/cinemediiia/routesList": [
    "91311",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "81188"
  ],
  "./_deziiign/hsespace/app": [
    "46345",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "22386"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/searchresults.tsx": [
    "77349",
    9,
    "96678"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookChaptersEdit": [
    "58466",
    9
  ],
  "./_deziiign/awards/routesList.tsx": [
    "80164",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "84709"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ai.svg": [
    "94285",
    1,
    "76254"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/styles": [
    "73222",
    9
  ],
  "./_deziiign/damuseum/routesList.tsx": [
    "99737",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35074"
  ],
  "./_deziiign/hsecolors/routesList": [
    "54706",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "40751"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/index.ts": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/sportmediiia/app.tsx": [
    "37223",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "4076"
  ],
  "./_geograffee/main/app.tsx": [
    "95508",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23509"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/styles": [
    "18476",
    9
  ],
  "./_competition/helpers/getCompetitionDate.ts": [
    "76662",
    9
  ],
  "./_deziiign/online/routesList.tsx": [
    "51217",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "2026"
  ],
  "./_competition/pages/ProjectsPage/CompetitionInfoPage": [
    "65548",
    9
  ],
  "./_deziiign/cgrave/const/CGRaveCompetitions.ts": [
    "97044",
    9,
    "15765"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-tags.tsx": [
    "22226",
    9,
    "99727"
  ],
  "./_deziiign/hsespace/routesList": [
    "82760",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31889"
  ],
  "./_deziiign/s-oriental/app": [
    "43791",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "39300"
  ],
  "./_deziiign/lmsmediiia/app.tsx": [
    "49241",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "99042"
  ],
  "./_deziiign/s-political-science/app.tsx": [
    "51367",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50188"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation.tsx": [
    "36014",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-authorDeziign.tsx": [
    "13598",
    9,
    "72339"
  ],
  "./_deziiign/urbanmediiia/app.tsx": [
    "22093",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5214"
  ],
  "./_deziiign/books/pages/sections/ps-buttons": [
    "94539",
    9,
    "48056"
  ],
  "./_deziiign/photomediiia/app": [
    "6213",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5478"
  ],
  "./_deziiign/prohse/app.tsx": [
    "9256",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23313"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListProjectsEdit": [
    "85441",
    9
  ],
  "./_deziiign/s-psychology/app": [
    "32336",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31145"
  ],
  "./_deziiign/hsespace/utils/index.ts": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/onlines/pages/readymag/english/intlTelInput": [
    "24471",
    9,
    "76604"
  ],
  "./_competition/pages/CreateCompetitionPage": [
    "40565",
    9,
    "23126"
  ],
  "./_competition/pages/CreateCompetitionPage/styles": [
    "31768",
    9
  ],
  "./_deziiign/fashionmediiia/app": [
    "96925",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "82734"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/flags.png": [
    "19831",
    1,
    "78652"
  ],
  "./_deziiign/dvadesign/styles": [
    "2739",
    9,
    "87120"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/OptionContentEditField.tsx": [
    "70009",
    9,
    "30818"
  ],
  "./_competition/pages/PreRegistrationResult/PreRegistrationResult.tsx": [
    "12225",
    9,
    "22056",
    "33754"
  ],
  "./_deziiign/prohse/routesList": [
    "20171",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21048"
  ],
  "./_deziiign/books/helpers/copyLink.ts": [
    "77885",
    9
  ],
  "./_deziiign/books/core/components/template/book-display-layout.tsx": [
    "70395",
    9,
    "52744"
  ],
  "./_deziiign/books/pages/BookListView": [
    "76584",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/s-chemistry/app.tsx": [
    "5001",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86130"
  ],
  "./_deziiign/books/core/components/bookCard/index": [
    "21273",
    9
  ],
  "./_competition/pages/PreRegistrationResult/": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/dvadesign/app": [
    "31062",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "86843"
  ],
  "./_deziiign/onlines/utils/": [
    "12216",
    9,
    "1953"
  ],
  "./_deziiign/books/pages/sections/ps-sub-information.tsx": [
    "12750",
    9,
    "82563"
  ],
  "./_deziiign/s-production/routesList.tsx": [
    "88157",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "11438"
  ],
  "./_deziiign/hsestart/styles": [
    "69730",
    9,
    "59551"
  ],
  "./_deziiign/iqmedia/app.tsx": [
    "5142",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "57563"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star3.svg": [
    "37310",
    1,
    "29587"
  ],
  "./_deziiign/continuumsite/app.tsx": [
    "36526",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "85059"
  ],
  "./_deziiign/books/routesList": [
    "26760",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64585"
  ],
  "./_deziiign/namesmediiia/routesList.tsx": [
    "89232",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "95145"
  ],
  "./_deziiign/onlines/app": [
    "29095",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "13836"
  ],
  "./_deziiign/school/routesList.tsx": [
    "262",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "87723"
  ],
  "./_deziiign/hsehh/routesList": [
    "11862",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "40283"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/damuseum/pages/roleAdmin/RoleAdminPage.tsx": [
    "16914",
    9,
    "99567"
  ],
  "./_deziiign/main/pages/projectDeziign/styles": [
    "16478",
    9,
    "13043"
  ],
  "./_deziiign/main/app": [
    "71236",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "47108",
    "20069"
  ],
  "./_deziiign/hsespacecreative/app": [
    "54370",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "26687"
  ],
  "./_deziiign/musicmediiia/app": [
    "62630",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "58923"
  ],
  "./_deziiign/awards/styles": [
    "37460",
    9,
    "98197"
  ],
  "./_deziiign/pro/app.tsx": [
    "31834",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "43559"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage.tsx": [
    "166",
    9
  ],
  "./_deziiign/s-advertising-and-pr/app.tsx": [
    "98286",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31267"
  ],
  "./_deziiign/books/core/components/helper/types/computed/ComputedBook": [
    "82452",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/changebg.svg": [
    "62674",
    1,
    "19919"
  ],
  "./_deziiign/damuseum/pages/EmployeesModerContext/EmployeesModerContext": [
    "62023",
    9,
    "35499",
    "96716"
  ],
  "./_deziiign/s-production/routesList": [
    "88157",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "11438"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArrayContentEditField": [
    "1116",
    9,
    "83917"
  ],
  "./_deziiign/onlines/pages/readymag/commonStyles.ts": [
    "28565",
    9,
    "72054"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/id.svg": [
    "5792",
    1,
    "24249"
  ],
  "./_deziiign/online/app": [
    "51165",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "53966"
  ],
  "./_deziiign/s-cognitive/app": [
    "94287",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "52100"
  ],
  "./_deziiign/kiiids/pages/roleAdmin/RoleAdminPage": [
    "52222",
    9,
    "92275"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/DvaDesignHeader.tsx": [
    "33655",
    9,
    "35004"
  ],
  "./_deziiign/s-international-relations/routesList": [
    "48390",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "99627"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPage": [
    "22108",
    9,
    "50333",
    "13357"
  ],
  "./_deziiign/books/core/common": [
    "62913",
    9,
    "82989"
  ],
  "./_deziiign/continuumsite/app": [
    "36526",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "85059"
  ],
  "./_deziiign/booksmediiia/app": [
    "25247",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71668"
  ],
  "./_deziiign/conceptmediiia/app": [
    "19869",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86702"
  ],
  "./_deziiign/awards/pages/EmployeesContext/index": [
    "31656",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "28689"
  ],
  "./_deziiign/creativemediiia/routesList": [
    "92375",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "77724"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star4.svg": [
    "54689",
    1,
    "71533"
  ],
  "./_deziiign/continuumsite/styles": [
    "5915",
    9,
    "9064"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookPlusIcon": [
    "37305",
    9
  ],
  "./_deziiign/hseanimation/routesList.tsx": [
    "27072",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "55417"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury": [
    "71795",
    9
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArray2ContentEditField.tsx": [
    "81290",
    9,
    "55863"
  ],
  "./_deziiign/s-philology/app": [
    "24826",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "10887"
  ],
  "./_deziiign/books/pages/BookEdit/index.ts": [
    "25525",
    9,
    "44086"
  ],
  "./_deziiign/books/core/components/shareButton/shareButton.tsx": [
    "88300",
    9,
    "45757"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/DvaDesignFooter": [
    "94043",
    9,
    "87464"
  ],
  "./_competition/components/CompetitionFormSuccess": [
    "2402",
    9,
    "63231"
  ],
  "./_deziiign/galllleryart/styles": [
    "78199",
    9,
    "52700"
  ],
  "./_deziiign/damuseum/routesList": [
    "99737",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35074"
  ],
  "./_competition/pages/PreRegistrationResult/style": [
    "33555",
    7,
    "66128"
  ],
  "./_deziiign/awards/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "70104",
    9,
    "35499",
    "55809"
  ],
  "./_deziiign/school/styles.tsx": [
    "6510",
    9,
    "40355"
  ],
  "./_geograffee/__COMMON__/commonRoutesEducation.tsx": [
    "42508",
    9,
    "50323",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "9452",
    "66673",
    "35499",
    "59037",
    "59017",
    "60204",
    "73645",
    "43709"
  ],
  "./_deziiign/greenaward/components/IndexTitle.tsx": [
    "69371",
    9,
    "88360"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCard.tsx": [
    "47486",
    9
  ],
  "./_deziiign/booksgallllery/ExtraPage/ExtraPage": [
    "79407",
    9,
    "56900"
  ],
  "./_deziiign/monalisatravels/routesList": [
    "58745",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "93410"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionGrid": [
    "1268",
    9
  ],
  "./_deziiign/main/pages/manageTag/ManageTagPage": [
    "88716",
    9,
    "3157",
    "61341"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBar.tsx": [
    "89260",
    9,
    "13908",
    "21655",
    "21565"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/styles": [
    "1094",
    9,
    "1979",
    "64171"
  ],
  "./_deziiign/s-biology/app": [
    "72594",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "77743"
  ],
  "./_deziiign/awards/routesList": [
    "80164",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "84709"
  ],
  "./_competition/routesList": [
    "1875",
    9,
    "78074",
    "56496"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module3.svg": [
    "79202",
    1,
    "35967"
  ],
  "./_deziiign/s-chemistry/routesList.tsx": [
    "77800",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "10897"
  ],
  "./_deziiign/prohse/routesList.tsx": [
    "20171",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21048"
  ],
  "./_deziiign/books/core/components/booksSearchBar/BooksSearchBarLayout.tsx": [
    "80714",
    9,
    "51735"
  ],
  "./_deziiign/onlines/pages/readymag/library/assets/what_is_branding_sm.jpg": [
    "81172",
    1,
    "55637"
  ],
  "./_deziiign/lpudesign/app": [
    "34912",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "36921"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-more-title": [
    "20187",
    9,
    "69512"
  ],
  "./_deziiign/books/core/components/booksSearchBar/": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/damuseum/styles.tsx": [
    "32402",
    9,
    "67110"
  ],
  "./_deziiign/naturemediiia/app": [
    "78614",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "51835"
  ],
  "./_deziiign/damuseum/utils/index.ts": [
    "8895",
    9,
    "67156"
  ],
  "./_deziiign/books/core/components/booksSearchBar/index": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/CombatEntitiesContentEditField.tsx": [
    "40683",
    9,
    "38776"
  ],
  "./_deziiign/sciencemediiia/routesList": [
    "38466",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "7775"
  ],
  "./_competition/components/CompetitionFormSuccess.tsx": [
    "2402",
    9,
    "63231"
  ],
  "./_competition/pages/ShortListPage/index.ts": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/hsespace/styles": [
    "98752",
    9,
    "12249"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationOneReadymag.svg": [
    "46855",
    1,
    "29356"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCard": [
    "47486",
    9
  ],
  "./_deziiign/lab/app": [
    "14678",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44571"
  ],
  "./_competition/pages/AllCompetitionsPage/index": [
    "60929",
    9,
    "14618"
  ],
  "./_deziiign/s-cognitive/app.tsx": [
    "94287",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "52100"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookVerticalCardIcon": [
    "1113",
    9
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/map": [
    "72684",
    9,
    "6602",
    "96678",
    "52477"
  ],
  "./_deziiign/books/core/components/grid/": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/exams/app.tsx": [
    "78503",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "57516"
  ],
  "./_deziiign/hsecreative/app": [
    "90600",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "38161"
  ],
  "./_competition/pages/SeasonsAdmin/SeasonsAdminPage": [
    "908",
    9,
    "10717"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionContexts.ts": [
    "2696",
    9
  ],
  "./_deziiign/books/core/components/booksSearchBar": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/kiiids/styles.tsx": [
    "19025",
    9,
    "99402"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Categories.tsx": [
    "93506",
    9
  ],
  "./_deziiign/books/core/components/booksSearchBar/index.ts": [
    "68671",
    9,
    "3924"
  ],
  "./_deziiign/books/core/components/helper/bookEvents.ts": [
    "97590",
    9,
    "73051"
  ],
  "./_deziiign/hsedesign/styles.tsx": [
    "91408",
    9,
    "49545"
  ],
  "./_geograffee/hsealumni/app.tsx": [
    "78689",
    9,
    "83762",
    "50323",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "97775",
    "92287",
    "71237",
    "9452",
    "66673",
    "35499",
    "59037",
    "59017",
    "60204",
    "73645",
    "27354"
  ],
  "./_deziiign/galllleryart/app.tsx": [
    "94354",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "35727"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/pen.svg": [
    "99569",
    1,
    "42218"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListProjectsEdit.tsx": [
    "85441",
    9
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/BookVerticalCardIcon.tsx": [
    "1113",
    9
  ],
  "./_deziiign/books/routesList.tsx": [
    "26760",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64585"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star1.svg": [
    "55036",
    1,
    "19789"
  ],
  "./_competition/pages/AllCompetitionsPage/sections/section-cgrave": [
    "10954",
    9,
    "2967"
  ],
  "./_deziiign/onlines/pages/readymag/english/intlTelInput.ts": [
    "24471",
    9,
    "76604"
  ],
  "./_deziiign/online/utils/": [
    "97367",
    9
  ],
  "./_deziiign/monalisatravels/app": [
    "23293",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "77655"
  ],
  "./_deziiign/fashion/routesList": [
    "97862",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31947"
  ],
  "./_deziiign/aimediiia/routesList": [
    "83870",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "42291"
  ],
  "./_deziiign/books/pages/tag/tagBookListViewLayout": [
    "85154",
    9,
    "18751"
  ],
  "./_deziiign/awards/pages/EmployeesContext": [
    "31656",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "28689"
  ],
  "./_deziiign/sportmediiia/routesList": [
    "81858",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "19743"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveJuriesPage.tsx": [
    "22570",
    9,
    "83863"
  ],
  "./_deziiign/hsedesign/routesList": [
    "30078",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "13779"
  ],
  "./_deziiign/s-production/app.tsx": [
    "42265",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "46699"
  ],
  "./_deziiign/s-mathematics/app.tsx": [
    "63417",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "3138"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/styles": [
    "93487",
    9,
    "77316"
  ],
  "./_deziiign/books/core/common.ts": [
    "62913",
    9,
    "82989"
  ],
  "./_competition/helpers/getCompetitionStatus.ts": [
    "30100",
    9
  ],
  "./_geograffee/__COMMON__/bookRoutes": [
    "33912",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "3938",
    "45633"
  ],
  "./_deziiign/hsehh/app": [
    "3651",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "94624"
  ],
  "./_competition/app.tsx": [
    "95668",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "13779",
    "64085"
  ],
  "./_deziiign/books/core/hook/api/useBookList": [
    "72617",
    9,
    "96850"
  ],
  "./_deziiign/hsespacecreative/app.tsx": [
    "54370",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "26687"
  ],
  "./_competition/pages/PreRegistrationResult/index": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/s-chemistry/routesList": [
    "77800",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "10897"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/rm.svg": [
    "87720",
    1,
    "29873"
  ],
  "./_deziiign/hsehh/routesList.tsx": [
    "11862",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "40283"
  ],
  "./_competition/components/style.ts": [
    "10301",
    9
  ],
  "./_deziiign/s-philosophy/app.tsx": [
    "9222",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50155"
  ],
  "./_deziiign/s-media/app.tsx": [
    "46343",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "14220"
  ],
  "./_deziiign/school/pages/init": [
    "74957",
    9,
    "48382"
  ],
  "./_deziiign/books/core/components/template/book-container-layout": [
    "74194",
    9,
    "55247"
  ],
  "./_deziiign/eventmediiia/routesList": [
    "4152",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "79073"
  ],
  "./_deziiign/s-physics/routesList.tsx": [
    "36487",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "39212"
  ],
  "./_deziiign/s-hsetto/app.tsx": [
    "97284",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "94949"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/MobileReadymag.svg": [
    "65300",
    1,
    "37804"
  ],
  "./_deziiign/hsespace/routesList.tsx": [
    "82760",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31889"
  ],
  "./_deziiign/booksgallllery/ExtraPage/ExtraPage.tsx": [
    "79407",
    9,
    "56900"
  ],
  "./_deziiign/foodmediiia/routesList": [
    "62124",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "53245"
  ],
  "./_competition/pages/ShortListPage/assets/LaurelWreathLeft.svg": [
    "865",
    1,
    "68250"
  ],
  "./_competition/pages/CreateCompetitionPage/index": [
    "40565",
    9,
    "23126"
  ],
  "./_competition/pages/ProjectsPage/index.ts": [
    "31708",
    9,
    "99309"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionAddTabs": [
    "1325",
    9
  ],
  "./_deziiign/conceptmediiia/app.tsx": [
    "19869",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86702"
  ],
  "./_deziiign/greenaward/app.tsx": [
    "39231",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "84116"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plantbig.svg": [
    "4083",
    1,
    "42736"
  ],
  "./_geograffee/dafes/app": [
    "76242",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "37071"
  ],
  "./_deziiign/superpuper/app": [
    "31858",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31887"
  ],
  "./_deziiign/hsespacecreative/routesList": [
    "9137",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "27402"
  ],
  "./_deziiign/booksgallllery/ExtraPage/": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-bottom": [
    "84958",
    9,
    "19955"
  ],
  "./_deziiign/books/pages/BookChapterCreate/index.ts": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/s-advertising-and-pr/app": [
    "98286",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31267"
  ],
  "./_deziiign/s-media/app": [
    "46343",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "14220"
  ],
  "./_deziiign/hsecreative/routesList.tsx": [
    "23307",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "99416"
  ],
  "./_deziiign/greenaward/utils/": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/hsedesign/utils/index": [
    "46106",
    9
  ],
  "./_deziiign/onlines/pages/readymag/commonStyles": [
    "28565",
    9,
    "72054"
  ],
  "./_deziiign/s-arthistory/app": [
    "56821",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "28927"
  ],
  "./_deziiign/iqmedia/routesList.tsx": [
    "70364",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "96525"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext": [
    "51397",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "67270"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext/index": [
    "4817",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "49674"
  ],
  "./_deziiign/cgrave/styles": [
    "1380",
    9,
    "5093"
  ],
  "./_deziiign/dvadesign/routesList.tsx": [
    "13069",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "53918"
  ],
  "./_deziiign/s-computer-science-and-engineering/app": [
    "24643",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "10720"
  ],
  "./_geograffee/main/routesList.tsx": [
    "29087",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "18900"
  ],
  "./_deziiign/sportmediiia/routesList.tsx": [
    "81858",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "19743"
  ],
  "./_competition/pages/CompetitionResultsPage/CompetitionResultsPage": [
    "10235",
    9,
    "22056"
  ],
  "./_deziiign/s-sociology/app.tsx": [
    "67953",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44234"
  ],
  "./_deziiign/dvadesign/styles.ts": [
    "2739",
    9,
    "87120"
  ],
  "./_deziiign/main/pages/admin/AdminPage.tsx": [
    "63176",
    9,
    "79665"
  ],
  "./_deziiign/fashionmediiia/app.tsx": [
    "96925",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "82734"
  ],
  "./_deziiign/books/core/components/tooltips/index.ts": [
    "40356",
    9
  ],
  "./_deziiign/s-history/app.tsx": [
    "25571",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83552"
  ],
  "./_deziiign/hsedesign/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "53649",
    9,
    "17642"
  ],
  "./_deziiign/cinemediiia/app.tsx": [
    "27588",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50533"
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationOverviewReadymag.svg": [
    "54856",
    1,
    "61457"
  ],
  "./_geograffee/__COMMON__/bookRoutes.tsx": [
    "33912",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "3938",
    "45633"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionAddTabs.ts": [
    "1325",
    9
  ],
  "./_competition/pages/PreRegistrationResult/PreRegistrationResult": [
    "12225",
    9,
    "22056",
    "33754"
  ],
  "./_deziiign/storiesmediiia/app.tsx": [
    "21600",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71865"
  ],
  "./_deziiign/adcrdafesnet/app.tsx": [
    "72893",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "68398"
  ],
  "./_deziiign/adcrdafesnet/pages/CgRaveNomineesPage.tsx": [
    "69662",
    9,
    "65235"
  ],
  "./_deziiign/mediiia/app": [
    "18689",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "24218"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/styles.ts": [
    "60017",
    9,
    "1979",
    "10314"
  ],
  "./_competition/pages/AllOpenCalls.tsx": [
    "62910",
    9,
    "2003"
  ],
  "./_deziiign/books/pages/BookEdit/sections/styles.ts": [
    "14954",
    9
  ],
  "./_deziiign/awards/pages/EmployeesModerContext/EmployeesModerContext": [
    "70104",
    9,
    "35499",
    "55809"
  ],
  "./_deziiign/s-architect/routesList": [
    "52833",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "74394"
  ],
  "./_deziiign/s-public-administration/app": [
    "21533",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "39662"
  ],
  "./_deziiign/hsedesign/components/IndexTitle": [
    "91797",
    9
  ],
  "./_deziiign/kiiids/utils/": [
    "25179",
    9,
    "14824"
  ],
  "./_deziiign/galllleryart/app": [
    "94354",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "35727"
  ],
  "./_deziiign/booksmediiia/routesList.tsx": [
    "69210",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44807"
  ],
  "./_deziiign/s-production/app": [
    "42265",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "46699"
  ],
  "./_deziiign/s-management/routesList.tsx": [
    "86269",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35054"
  ],
  "./_deziiign/exams/routesList": [
    "35170",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "56031"
  ],
  "./_deziiign/s-architect/app": [
    "30162",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "9775"
  ],
  "./_geograffee/__COMMON__/commonRoutesEducation": [
    "42508",
    9,
    "50323",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "9452",
    "66673",
    "35499",
    "59037",
    "59017",
    "60204",
    "73645",
    "43709"
  ],
  "./_deziiign/awards/pages/roleAdmin/RoleAdminPage": [
    "51697",
    9,
    "73706"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/index.ts": [
    "71795",
    9
  ],
  "./_deziiign/books/pages/sections/ps-commerce": [
    "21934",
    9,
    "51811"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/EmployeesContext": [
    "33981",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "73358"
  ],
  "./_deziiign/main/pages/moderHseView/ProjectTilesMapDeziiign": [
    "61848",
    9,
    "45825"
  ],
  "./_competition/helpers/getCompetitionStatus": [
    "30100",
    9
  ],
  "./_deziiign/books/core/components/shareButton/shareButton": [
    "88300",
    9,
    "45757"
  ],
  "./_deziiign/booksgallllery/routesList": [
    "14518",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "98363"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-more-title.tsx": [
    "20187",
    9,
    "69512"
  ],
  "./_deziiign/storiesmediiia/app": [
    "21600",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71865"
  ],
  "./_deziiign/books/pages/sections/ps-sub-information": [
    "12750",
    9,
    "82563"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/index.ts": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/lmshse/routesList.tsx": [
    "89406",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21267"
  ],
  "./_deziiign/awards/components/IndexTitle.tsx": [
    "81233",
    9,
    "96362"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-title": [
    "35075",
    9,
    "95008"
  ],
  "./_deziiign/sciencemediiia/routesList.tsx": [
    "38466",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "7775"
  ],
  "./_competition/pages/AllCompetitionsPage/components/HintInfo.tsx": [
    "70085",
    9
  ],
  "./_deziiign/hsedesign/utils": [
    "46106",
    9
  ],
  "./_deziiign/books/pages/BookEdit/index": [
    "25525",
    9,
    "44086"
  ],
  "./_deziiign/brnd/app": [
    "8109",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23902"
  ],
  "./_deziiign/historymediiia/routesList.tsx": [
    "93384",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "24881"
  ],
  "./_competition/components/imageTS.png": [
    "12968",
    1,
    "9489"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/pin1.svg": [
    "60232",
    1,
    "46225"
  ],
  "./_deziiign/books/core/components/designerSearch/DesignerSearch": [
    "10268",
    9,
    "21655",
    "42029"
  ],
  "./_deziiign/books/pages/BookEdit/styles.ts": [
    "5171",
    9
  ],
  "./_deziiign/books/pages/BookView/components/BookTools.tsx": [
    "67079",
    9,
    "2325"
  ],
  "./_deziiign/main/pages/projectDeziign/components/ProjectImage": [
    "77159",
    9,
    "6636"
  ],
  "./_deziiign/books/core/components/datePickerRange/styles": [
    "63545",
    9,
    "82850"
  ],
  "./_competition/app": [
    "95668",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "13779",
    "64085"
  ],
  "./_deziiign/onlines/pages/readymag/turkey/styles": [
    "60017",
    9,
    "1979",
    "10314"
  ],
  "./_deziiign/hsedesign/routesList.tsx": [
    "30078",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "13779"
  ],
  "./_deziiign/s-biology/routesList": [
    "28257",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "73402"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/CategoryEdit.tsx": [
    "38310",
    9
  ],
  "./_deziiign/onlines/pages/readymag/turkey/ReadymagPageTR": [
    "36272",
    9,
    "1979",
    "10314",
    "52393"
  ],
  "./_deziiign/main/pages/projectDeziign/": [
    "50538",
    9,
    "19955",
    "61186",
    "15063"
  ],
  "./_deziiign/books/pages/BookView/components/BookHeader.tsx": [
    "6371",
    9,
    "95360"
  ],
  "./_competition/pages/ShortListPage/PreShortListPage": [
    "97566",
    9
  ],
  "./_competition/pages/ShortListPage/ShortListPage": [
    "37613",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionEditPlus.tsx": [
    "89004",
    9,
    "52701"
  ],
  "./_deziiign/books/core/components/designerSearch/designerSearchAuth.tsx": [
    "3978",
    9,
    "21655"
  ],
  "./_deziiign/s-computer-science-and-engineering/routesList.tsx": [
    "81206",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "66107"
  ],
  "./_deziiign/s-pro/routesList.tsx": [
    "41741",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35134"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/styles": [
    "86409",
    9,
    "94930"
  ],
  "./_deziiign/books/pages/tag/tagBookListView": [
    "29236",
    9,
    "13908",
    "21655",
    "21565",
    "57493"
  ],
  "./_deziiign/game/routesList.tsx": [
    "71368",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "75345"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module2.svg": [
    "82931",
    1,
    "65936"
  ],
  "./_deziiign/s-political-science/app": [
    "51367",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "50188"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/bgDvaDesign.jpg": [
    "63081",
    1,
    "72658"
  ],
  "./_competition/components/CompetitionDropdown": [
    "22878",
    9
  ],
  "./_deziiign/hsestart/routesList.tsx": [
    "94962",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "63279"
  ],
  "./_deziiign/namesmediiia/routesList": [
    "89232",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "95145"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagContentEditTextField.tsx": [
    "14771",
    9,
    "79056"
  ],
  "./_deziiign/cgrave/pages/CgRaveNomineesPage.tsx": [
    "11278",
    9,
    "8739"
  ],
  "./_competition/pages/ShortListPage": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/exams/routesList.tsx": [
    "35170",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "56031"
  ],
  "./_deziiign/lmsmediiia/app": [
    "49241",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "99042"
  ],
  "./_deziiign/s-public-administration/routesList": [
    "96916",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "51125"
  ],
  "./_competition/components/CompetitionDropdown.tsx": [
    "22878",
    9
  ],
  "./_deziiign/s-geography/app.tsx": [
    "84909",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "12670"
  ],
  "./_deziiign/books/core/components/grid/index": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/booksgallllery/app": [
    "76643",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "66688"
  ],
  "./_deziiign/sciencemediiia/app.tsx": [
    "65447",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "58028"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringArrayContentEditField.tsx": [
    "1116",
    9,
    "83917"
  ],
  "./_deziiign/damuseum/utils": [
    "8895",
    9,
    "67156"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/searchblack.svg": [
    "93583",
    1,
    "87428"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/index.ts": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/awards/pages/EmployeesContext/EmployeesContext.tsx": [
    "59929",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "56043"
  ],
  "./_deziiign/books/pages/BookChapterCreate": [
    "45234",
    9,
    "95855"
  ],
  "./_deziiign/books/pages/BookListView/index": [
    "76584",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/styles.tsx": [
    "20509",
    9
  ],
  "./_deziiign/online/utils/index": [
    "97367",
    9
  ],
  "./_deziiign/hsecreativehub/routesList": [
    "71242",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "57303"
  ],
  "./_deziiign/galllleryart/routesList": [
    "43137",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "93914"
  ],
  "./_deziiign/designmediiia/routesList.tsx": [
    "17398",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "3323"
  ],
  "./_deziiign/main/pages/moderHseView/moderHseView.tsx": [
    "53627",
    9,
    "99272"
  ],
  "./_deziiign/s-fashion/app": [
    "40127",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "93492"
  ],
  "./_deziiign/lmshsecreative/app.tsx": [
    "59520",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64665"
  ],
  "./_deziiign/s-international-relations/app": [
    "57715",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "11408"
  ],
  "./_deziiign/s-music/app": [
    "62310",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "98411"
  ],
  "./_deziiign/superpuper/app.tsx": [
    "31858",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31887"
  ],
  "./_deziiign/s-cognitive/routesList": [
    "92970",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6167"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/searchsm.svg": [
    "39150",
    1,
    "91907"
  ],
  "./_competition/pages/ShortListPage/PreShortListPage.tsx": [
    "97566",
    9
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/styles": [
    "20509",
    9
  ],
  "./_deziiign/adcrdafesnet/routesList.tsx": [
    "84852",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "39797"
  ],
  "./_deziiign/books/core/components/bookCard": [
    "21273",
    9
  ],
  "./_deziiign/superpuper/routesList.tsx": [
    "76673",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23130"
  ],
  "./_deziiign/s-sociology/app": [
    "67953",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44234"
  ],
  "./_deziiign/greenaward/app": [
    "39231",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "84116"
  ],
  "./_deziiign/s-media/routesList": [
    "88674",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "89023"
  ],
  "./_competition/pages/JuryPage/": [
    "5122",
    9,
    "91967"
  ],
  "./_competition/const": [
    "19408",
    9
  ],
  "./_deziiign/s-chemistry/app": [
    "5001",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86130"
  ],
  "./_deziiign/books/app.tsx": [
    "52905",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64585"
  ],
  "./_deziiign/lpudesign/routesList.tsx": [
    "56163",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "42368"
  ],
  "./_deziiign/onlines/pages/readymag/kz/ReadymagPageKZ": [
    "45660",
    9,
    "1979",
    "13918",
    "42722",
    "98042",
    "32301"
  ],
  "./_deziiign/lpudesign/styles.tsx": [
    "72095",
    9,
    "29364"
  ],
  "./_deziiign/lpudesign/app.tsx": [
    "34912",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "36921"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-image.tsx": [
    "75542",
    9,
    "13243"
  ],
  "./_competition/pages/AllCompetitionsPage/components/HintInfo": [
    "70085",
    9
  ],
  "./_deziiign/onlines/pages/readymag/library/LibraryPage": [
    "8276",
    9,
    "1979",
    "13918",
    "63342",
    "95541"
  ],
  "./_deziiign/s-culturology/routesList": [
    "49467",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "76872"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/camera.svg": [
    "12413",
    1,
    "93262"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plant.svg": [
    "59903",
    1,
    "7540"
  ],
  "./_deziiign/musicmediiia/routesList": [
    "17469",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23406"
  ],
  "./_deziiign/greenaward/utils/index.ts": [
    "96912",
    9,
    "94249"
  ],
  "./_deziiign/hsespace/utils": [
    "93514",
    9,
    "65303"
  ],
  "./_competition/pages/CompetitionTable/CompetitionTable.tsx": [
    "72383",
    9,
    "22056",
    "38708"
  ],
  "./_deziiign/books/core/components/helper/types/computed/ComputedBook.ts": [
    "82452",
    9
  ],
  "./_deziiign/hsespacefilm/routesList.tsx": [
    "18438",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "555"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Platforms.tsx": [
    "59628",
    9
  ],
  "./_deziiign/s-urban-development/app": [
    "69291",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "61528"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionJuryCard.tsx": [
    "21919",
    9
  ],
  "./_deziiign/main/pages/moderHseView/index": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/s-geography/routesList": [
    "10596",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97093"
  ],
  "./_competition/pages/CompetitionTable/CompetitionTable": [
    "72383",
    9,
    "22056",
    "38708"
  ],
  "./_competition/pages/ProjectsPage/index": [
    "31708",
    9,
    "99309"
  ],
  "./_competition/components/CompetitionTagLine.tsx": [
    "23659",
    9
  ],
  "./_deziiign/main/pages/moderView/moderView.tsx": [
    "29397",
    9,
    "51382"
  ],
  "./_deziiign/s-urban-development/routesList": [
    "14622",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "14419"
  ],
  "./_deziiign/onlines/utils": [
    "12216",
    9,
    "1953"
  ],
  "./_competition/pages/ShortListPage/styles.ts": [
    "42270",
    9
  ],
  "./_deziiign/books/core/components/bookCard/assets/book-more-circle.svg": [
    "84667",
    1,
    "66760"
  ],
  "./_competition/pages/AllCompetitionsPage/styled.ts": [
    "70740",
    9
  ],
  "./_competition/pages/EmptyPage": [
    "90798",
    9,
    "81251"
  ],
  "./_deziiign/s-advertising-and-pr/routesList": [
    "2725",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "49510"
  ],
  "./_competition/helpers/getCompetitionDate": [
    "76662",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/competitionTagsCloud": [
    "40443",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateRaitingCompetiton": [
    "46895",
    9,
    "50333",
    "96228"
  ],
  "./_deziiign/mediiia/app.tsx": [
    "18689",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "24218"
  ],
  "./_geograffee/dafes/routesList": [
    "58305",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "43290"
  ],
  "./_deziiign/s-economy/app": [
    "30587",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "69032"
  ],
  "./_deziiign/exams/app": [
    "78503",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "57516"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/EmployeesModerContext": [
    "95636",
    9,
    "35499",
    "28821"
  ],
  "./_deziiign/hsedesign/pages/roleAdmin/RoleAdminPage": [
    "2925",
    9,
    "99358"
  ],
  "./_deziiign/s-economy/routesList": [
    "59950",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "8771"
  ],
  "./_deziiign/onlines/pages/readymag/images/OnlinesSchedule.pdf": [
    "11664",
    1,
    "45321"
  ],
  "./_deziiign/designmediiia/routesList": [
    "17398",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "3323"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/index": [
    "51397",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "67270"
  ],
  "./_deziiign/s-hsetto/app": [
    "97284",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "94949"
  ],
  "./_deziiign/s-philology/app.tsx": [
    "24826",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "10887"
  ],
  "./_deziiign/s-jurisprudence/app.tsx": [
    "87039",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64605"
  ],
  "./_deziiign/s-physics/app": [
    "76764",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "89997"
  ],
  "./_deziiign/hsecolors/app.tsx": [
    "19735",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "43452"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionView": [
    "255",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/CreateCompetitionPage.tsx": [
    "18314",
    9
  ],
  "./_competition/pages/CompetitionResultsPage/": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/s-software-engineering/app": [
    "99790",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "14115"
  ],
  "./_competition/pages/ShortListPage/index": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/hsespace/styles.tsx": [
    "98752",
    9,
    "12249"
  ],
  "./_deziiign/books/core/components/bookCard/style": [
    "94938",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/iqmedia/app": [
    "5142",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "57563"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/styles": [
    "63011",
    9
  ],
  "./_competition/components/SendProjectButton": [
    "26709",
    9
  ],
  "./_deziiign/books/core/components/template/book-container-layout.tsx": [
    "74194",
    9,
    "55247"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext/EmployeesContext": [
    "32497",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "32522"
  ],
  "./_deziiign/s-oriental/app.tsx": [
    "43791",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "39300"
  ],
  "./_deziiign/s-sociology/routesList": [
    "82256",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "26089"
  ],
  "./_competition/pages/CreateCompetitionPage/styles.tsx": [
    "31768",
    9
  ],
  "./_competition/components/CompetitionTagLine": [
    "23659",
    9
  ],
  "./_deziiign/s-philology/routesList": [
    "22217",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "1490"
  ],
  "./_competition/components/ImageMob.jpg": [
    "10213",
    1,
    "3782"
  ],
  "./_deziiign/lab/routesList": [
    "59821",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "68990"
  ],
  "./_deziiign/books/pages/sections/ps-commerce.tsx": [
    "21934",
    9,
    "51811"
  ],
  "./_competition/helpers/getDaysToFinish": [
    "20572",
    9
  ],
  "./_deziiign/hsedesign/app.tsx": [
    "66841",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "13779",
    "99554"
  ],
  "./_deziiign/online/app.tsx": [
    "51165",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "53966"
  ],
  "./_deziiign/awards/utils/": [
    "97022",
    9,
    "7539"
  ],
  "./_deziiign/books/pages/sections/assets/alert.svg": [
    "87408",
    1,
    "24681"
  ],
  "./_deziiign/s-fashion/routesList.tsx": [
    "7386",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "80679"
  ],
  "./_competition/pages/CompetitionTable/index.ts": [
    "69432",
    9,
    "22056",
    "38708",
    "91137"
  ],
  "./_deziiign/booksgallllery/ExtraPage/index.ts": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/week.svg": [
    "38988",
    1,
    "55677"
  ],
  "./_deziiign/books/pages/tag/tagBookListView.tsx": [
    "29236",
    9,
    "13908",
    "21655",
    "21565",
    "57493"
  ],
  "./_deziiign/dvadesign/components/DvaDesignFooter/DvaDesignFooter.tsx": [
    "94043",
    9,
    "87464"
  ],
  "./_deziiign/main/pages/eduTagAdmin/EduTagAdminPage.tsx": [
    "97728",
    9,
    "27769"
  ],
  "./_deziiign/fashionmediiia/routesList.tsx": [
    "77396",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "7477"
  ],
  "./_deziiign/hsecreative/app.tsx": [
    "90600",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "38161"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext": [
    "51851",
    9,
    "35499",
    "13240"
  ],
  "./_deziiign/hsestart/app.tsx": [
    "36503",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "85244"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagContentEditTextField": [
    "14771",
    9,
    "79056"
  ],
  "./_deziiign/hsedesign/pages/StatisticsPage/StatisticsPage.tsx": [
    "32042",
    9,
    "13908",
    "26324",
    "10039"
  ],
  "./_deziiign/onlines/pages/readymag/video/styles.ts": [
    "48516",
    9,
    "73637"
  ],
  "./_deziiign/s-mathematics/routesList.tsx": [
    "82264",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "15905"
  ],
  "./_deziiign/continuumsite/routesList": [
    "97765",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6886"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/TagsTypeSwitcher": [
    "51152",
    9
  ],
  "./_deziiign/main/pages/eduTagAdmin/index": [
    "25672",
    9,
    "27769",
    "32049"
  ],
  "./_deziiign/s-architect/app.tsx": [
    "30162",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "9775"
  ],
  "./_deziiign/online/utils/index.ts": [
    "97367",
    9
  ],
  "./_deziiign/brnd/routesList.tsx": [
    "59684",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "21733"
  ],
  "./_deziiign/s-international-relations/app.tsx": [
    "57715",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "11408"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/DvaDesignHeader": [
    "33655",
    9,
    "35004"
  ],
  "./_deziiign/books/core/components/template/book-display-layout": [
    "70395",
    9,
    "52744"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/EmployeesContext.tsx": [
    "33981",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "73358"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ae.svg": [
    "75721",
    1,
    "33106"
  ],
  "./_competition/pages/AllCompetitionsPage/types.ts": [
    "29334",
    9
  ],
  "./_deziiign/books/core/components/bookCard/bookCard": [
    "35468",
    9
  ],
  "./_deziiign/s-advertising-and-pr/routesList.tsx": [
    "2725",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "49510"
  ],
  "./_geograffee/places/pages/tagPlaces/TagPlacesPage": [
    "87819",
    9,
    "14488"
  ],
  "./_deziiign/main/pages/moderView/": [
    "15597",
    9,
    "51382",
    "70494"
  ],
  "./_deziiign/lmsmediiia/routesList": [
    "74328",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54209"
  ],
  "./_deziiign/books/pages/BookListView/index.ts": [
    "76584",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "89521"
  ],
  "./_deziiign/foodmediiia/app.tsx": [
    "86805",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "59126"
  ],
  "./_deziiign/books/core/components/bookCard/style.ts": [
    "94938",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module4.svg": [
    "7725",
    1,
    "96798"
  ],
  "./_deziiign/books/core/book-delegate": [
    "88325",
    9
  ],
  "./_deziiign/eventmediiia/app": [
    "98329",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5890"
  ],
  "./_deziiign/greenaward/routesList.tsx": [
    "29293",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23591"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/assets/next.svg": [
    "66407",
    1,
    "24780"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/s-cognitive/routesList.tsx": [
    "92970",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "6167"
  ],
  "./_deziiign/onlines/utils/index.ts": [
    "12216",
    9,
    "1953"
  ],
  "./_deziiign/s-computer-science-and-engineering/routesList": [
    "81206",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "66107"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/FloatingPager.tsx": [
    "85524",
    9
  ],
  "./_deziiign/school/app.tsx": [
    "46931",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44080"
  ],
  "./_deziiign/books/core/components/grid/index.tsx": [
    "51520",
    9,
    "51833"
  ],
  "./_deziiign/ageytomesh/routesList.tsx": [
    "92044",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "67741"
  ],
  "./_deziiign/awards/pages/EmployeesContext/index.tsx": [
    "31656",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "28689"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext": [
    "67884",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "11325"
  ],
  "./_deziiign/main/styles.tsx": [
    "94163",
    9,
    "28592"
  ],
  "./_deziiign/s-music/app.tsx": [
    "62310",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "98411"
  ],
  "./_deziiign/books/core/components/booksSearchBar/style": [
    "17998",
    9,
    "56067"
  ],
  "./_deziiign/greenaward/styles": [
    "52890",
    9,
    "32455"
  ],
  "./_deziiign/onlines/pages/readymag/kz/stylesKZ": [
    "60449",
    9,
    "1979",
    "13918",
    "98042"
  ],
  "./_deziiign/books/core/components/controllers/BooksButchController": [
    "90929",
    9,
    "68778"
  ],
  "./_deziiign/creativemediiia/routesList.tsx": [
    "92375",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "77724"
  ],
  "./_deziiign/continuumsite/img/image_1920.png": [
    "89373",
    1,
    "48046"
  ],
  "./_competition/pages/SeasonsAdmin/SeasonsAdminPage.tsx": [
    "908",
    9,
    "10717"
  ],
  "./_deziiign/damuseum/utils/": [
    "8895",
    9,
    "67156"
  ],
  "./_deziiign/books/core/components/tooltips": [
    "40356",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-image": [
    "75542",
    9,
    "13243"
  ],
  "./_competition/pages/PreRegistrationResult/style.ts": [
    "33555",
    7,
    "66128"
  ],
  "./_deziiign/hsespace/app.tsx": [
    "46345",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "22386"
  ],
  "./_deziiign/online/styles.tsx": [
    "10509",
    9,
    "50718"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/reducer/reducer.ts": [
    "68649",
    9,
    "41906"
  ],
  "./_deziiign/awards/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "56581",
    9,
    "16646"
  ],
  "./_deziiign/books/pages/BookView/components/MainBookTitle.tsx": [
    "53341",
    9
  ],
  "./_deziiign/books/core/components/template/book-container-layout.styles.tsx": [
    "5703",
    9,
    "1877"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/": [
    "71795",
    9
  ],
  "./_deziiign/s-pro/routesList": [
    "41741",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "35134"
  ],
  "./_geograffee/academy/routesList.tsx": [
    "28768",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "71769"
  ],
  "./_deziiign/online/routesList": [
    "51217",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "2026"
  ],
  "./_competition/pages/CompetitionsAdmin/CompetitionsAdminPage.tsx": [
    "22108",
    9,
    "50333",
    "13357"
  ],
  "./_competition/pages/CompetitionTable/": [
    "69432",
    9,
    "22056",
    "38708",
    "91137"
  ],
  "./_deziiign/fashion/routesList.tsx": [
    "97862",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31947"
  ],
  "./_deziiign/onlines/utils/index": [
    "12216",
    9,
    "1953"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/": [
    "51397",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "67270"
  ],
  "./_deziiign/s-software-engineering/routesList": [
    "45829",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "5318"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/plus.svg": [
    "81440",
    1,
    "40729"
  ],
  "./_deziiign/s-history/routesList": [
    "74294",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "58971"
  ],
  "./_deziiign/hsespace/utils/index": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/overview/module1.svg": [
    "21920",
    1,
    "80697"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibraryPage.tsx": [
    "8276",
    9,
    "1979",
    "13918",
    "63342",
    "95541"
  ],
  "./_competition/pages/CreateCompetitionPage/CreateRaitingCompetiton.tsx": [
    "46895",
    9,
    "50333",
    "96228"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/index": [
    "71795",
    9
  ],
  "./_deziiign/hsestart/app": [
    "36503",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "85244"
  ],
  "./_competition/pages/ShortListPage/styles": [
    "42270",
    9
  ],
  "./_competition/components/TellingStoriesSuccess.tsx": [
    "43479",
    9,
    "10684"
  ],
  "./_deziiign/greenaward/routesList": [
    "29293",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23591"
  ],
  "./_competition/pages/web.svg": [
    "79274",
    1,
    "14519"
  ],
  "./_deziiign/lmshse/app": [
    "59755",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "7512"
  ],
  "./_geograffee/main/app": [
    "95508",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23509"
  ],
  "./_competition/pages/CompetitionTable/index": [
    "69432",
    9,
    "22056",
    "38708",
    "91137"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useShowcaseTexts.ts": [
    "61644",
    9
  ],
  "./_deziiign/books/core/components/chaptersNavigation/ChaptersNavigation": [
    "36014",
    9
  ],
  "./_deziiign/s-fashion/app.tsx": [
    "40127",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "93492"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/assets/vertical_card.svg": [
    "96378",
    1,
    "57159"
  ],
  "./_deziiign/cgrave/routesList": [
    "7524",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54821"
  ],
  "./_deziiign/onlines/pages/readymag/InitPage": [
    "82021",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "98042",
    "32301",
    "67269",
    "53414"
  ],
  "./_deziiign/kiiids/pages/roleAdmin/RoleAdminPage.tsx": [
    "52222",
    9,
    "92275"
  ],
  "./_deziiign/awards/app.tsx": [
    "10445",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "89054"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/MainTagAdminPage": [
    "166",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/CategoryEdit": [
    "38310",
    9
  ],
  "./_deziiign/awards/pages/EmployeesContext/": [
    "31656",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "28689"
  ],
  "./_competition/pages/JuryPage/styles.ts": [
    "80070",
    9
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-longread": [
    "55855",
    9,
    "20004"
  ],
  "./_deziiign/books/core/components/designerSearch/styles.tsx": [
    "46609",
    9,
    "97450"
  ],
  "./_deziiign/kiiids/utils/index.ts": [
    "25179",
    9,
    "14824"
  ],
  "./_deziiign/ageytomesh/app.tsx": [
    "61045",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "24822"
  ],
  "./_competition/pages/ShortListPage/ShortListPage.tsx": [
    "37613",
    9
  ],
  "./_deziiign/books/pages/BookEdit/sections/ProtectSection": [
    "80194",
    9
  ],
  "./_deziiign/cgrave/pages/CgRaveJuriesPage.tsx": [
    "55002",
    9,
    "31591"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagPage.tsx": [
    "88716",
    9,
    "3157",
    "61341"
  ],
  "./_deziiign/game/app": [
    "86185",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "49170"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanArrayContentEditField.tsx": [
    "24361",
    9,
    "34418"
  ],
  "./_deziiign/profmediiia/routesList": [
    "10777",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "67810"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionView.tsx": [
    "255",
    9
  ],
  "./_deziiign/hsedesign/app": [
    "66841",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "13779",
    "99554"
  ],
  "./_deziiign/s-software-engineering/routesList.tsx": [
    "45829",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "5318"
  ],
  "./_deziiign/books/helpers/copyLink": [
    "77885",
    9
  ],
  "./_deziiign/naturemediiia/routesList": [
    "93869",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97758"
  ],
  "./_deziiign/onlines/pages/readymag/video/VideoPage": [
    "48580",
    9,
    "1979",
    "13918",
    "63342",
    "74917"
  ],
  "./_deziiign/books/pages/BookEdit/components/CustomInput": [
    "40837",
    9,
    "99142"
  ],
  "./_deziiign/kiiids/pages/EmployeesContext/index.tsx": [
    "51397",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "67270"
  ],
  "./_deziiign/books/core/components/bookCard/": [
    "21273",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/types": [
    "94393",
    9
  ],
  "./_deziiign/naturemediiia/app.tsx": [
    "78614",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "51835"
  ],
  "./_competition/pages/AllCompetitionsPage/types": [
    "29334",
    9
  ],
  "./_deziiign/books/pages/BookEdit/": [
    "25525",
    9,
    "44086"
  ],
  "./_deziiign/conceptmediiia/routesList.tsx": [
    "83700",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "62165"
  ],
  "./_deziiign/books/pages/BookEdit/components/BookCards/BookCardList.tsx": [
    "33014",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/EmployeesContext": [
    "51106",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "6879"
  ],
  "./_deziiign/hsespace/utils/": [
    "93514",
    9,
    "65303"
  ],
  "./_deziiign/lmshsecreative/routesList.tsx": [
    "83811",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "91424"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/StringContentEditField.tsx": [
    "32449",
    9,
    "50042"
  ],
  "./_deziiign/main/pages/tagAdmin/TagAdminPage.tsx": [
    "44676",
    9,
    "645"
  ],
  "./_deziiign/online/utils": [
    "97367",
    9
  ],
  "./_deziiign/onlines/pages/readymag/turkey/ReadymagPageTR.tsx": [
    "36272",
    9,
    "1979",
    "10314",
    "52393"
  ],
  "./_deziiign/s-psychology/app.tsx": [
    "32336",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31145"
  ],
  "./_deziiign/s-software-engineering/app.tsx": [
    "99790",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "14115"
  ],
  "./_deziiign/school/styles": [
    "6510",
    9,
    "40355"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/ShortListWinnerProjectsEdit.tsx": [
    "20260",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/Components/CompetitionCertificatesBlock": [
    "2850",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/IllustrationThreeReadymag.svg": [
    "6219",
    1,
    "76184"
  ],
  "./_deziiign/onlines/pages/readymag/kz/stylesKZ.ts": [
    "60449",
    9,
    "1979",
    "13918",
    "98042"
  ],
  "./_competition/pages/ProjectsPage/CompetitionInfoPage.tsx": [
    "65548",
    9
  ],
  "./_deziiign/hsehh/styles.tsx": [
    "80446",
    9,
    "78803"
  ],
  "./_competition/pages/AllCompetitionsPage": [
    "60929",
    9,
    "14618"
  ],
  "./_deziiign/onlines/OnlinesMetaTags.tsx": [
    "32482",
    9,
    "42143"
  ],
  "./_deziiign/awards/app": [
    "10445",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "89054"
  ],
  "./_deziiign/books/pages/tag/": [
    "17800",
    9,
    "13908",
    "21655",
    "21565",
    "59761"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionJuryCard": [
    "21919",
    9
  ],
  "./_deziiign/booksgallllery/ExtraPage/index": [
    "50376",
    9,
    "86001"
  ],
  "./_deziiign/books/core/components/bookCard/bookCard.tsx": [
    "35468",
    9
  ],
  "./_deziiign/s-political-science/routesList": [
    "7938",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "90783"
  ],
  "./_deziiign/lmsmediiia/routesList.tsx": [
    "74328",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54209"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-tags": [
    "22226",
    9,
    "99727"
  ],
  "./_deziiign/s-management/app.tsx": [
    "46822",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "46507"
  ],
  "./_deziiign/s-mathematics/routesList": [
    "82264",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "15905"
  ],
  "./_deziiign/s-urban-development/app.tsx": [
    "69291",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "61528"
  ],
  "./_deziiign/main/pages/tagAdmin/index": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_competition/pages/AllCompetitionsPage/const/hseSpaceCompetitionContexts.ts": [
    "62690",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/calendarReadymag.svg": [
    "8324",
    1,
    "99205"
  ],
  "./_deziiign/kiiids/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "43782",
    9,
    "33355"
  ],
  "./_deziiign/school/utils/index": [
    "89716",
    9,
    "99509"
  ],
  "./_deziiign/books/core/components/designerSearch/styles": [
    "46609",
    9,
    "97450"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/ps.svg": [
    "48820",
    1,
    "98453"
  ],
  "./_deziiign/books/pages/sections/ps-image": [
    "9421",
    9
  ],
  "./_competition/pages/PreRegistrationResult/index.ts": [
    "97126",
    9,
    "22056",
    "33754",
    "58507"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/BooleanArrayContentEditField": [
    "24361",
    9,
    "34418"
  ],
  "./_deziiign/books/pages/tag/tagBookListViewLayout.tsx": [
    "85154",
    9,
    "18751"
  ],
  "./_deziiign/books/pages/BookChapterCreate/BookChapterCreate": [
    "52636",
    9,
    "85357"
  ],
  "./_deziiign/hsecreative/routesList": [
    "23307",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "99416"
  ],
  "./_deziiign/awards/styles.tsx": [
    "37460",
    9,
    "98197"
  ],
  "./_deziiign/damuseum/utils/index": [
    "8895",
    9,
    "67156"
  ],
  "./_deziiign/namesmediiia/app.tsx": [
    "47185",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "55402"
  ],
  "./_deziiign/sciencemediiia/app": [
    "65447",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "58028"
  ],
  "./_competition/pages/CreateCompetitionPage/sections/ContextsSections/ContextsSection": [
    "84390",
    9
  ],
  "./_competition/pages/ShortListPage/": [
    "13978",
    9,
    "86439"
  ],
  "./_deziiign/transfermediiia/app.tsx": [
    "56774",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "70987"
  ],
  "./_geograffee/places/pages/tagPlaces/components/images/flag.svg": [
    "58764",
    1,
    "19421"
  ],
  "./_deziiign/s-music/routesList": [
    "10621",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31790"
  ],
  "./_competition/pages/AllCompetitionsPage/const/competitionContexts": [
    "2696",
    9
  ],
  "./_deziiign/hsespacefilm/routesList": [
    "18438",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "555"
  ],
  "./_deziiign/profmediiia/routesList.tsx": [
    "10777",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "67810"
  ],
  "./_deziiign/s-cinema/app.tsx": [
    "64646",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "363"
  ],
  "./_competition/pages/AllCompetitionsPage/hooks/useCompetitionsTabs": [
    "70789",
    9
  ],
  "./_competition/components/Image.jpg": [
    "95503",
    1,
    "44676"
  ],
  "./_competition/pages/AllCompetitionsPage/AllCompetitionsPage": [
    "21593",
    9
  ],
  "./_deziiign/school/app": [
    "46931",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44080"
  ],
  "./_deziiign/main/pages/tagAdmin/": [
    "15406",
    9,
    "645",
    "78627"
  ],
  "./_deziiign/books/core/components/bookCard/index.tsx": [
    "21273",
    9
  ],
  "./_deziiign/cgrave/app.tsx": [
    "48621",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "63934"
  ],
  "./_deziiign/continuumsite/components/ContinuumPage": [
    "43455",
    9,
    "54452"
  ],
  "./_deziiign/artmediiia/app.tsx": [
    "43916",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "6749"
  ],
  "./_deziiign/awards/pages/roleAdmin/RoleAdminPage.tsx": [
    "51697",
    9,
    "73706"
  ],
  "./_deziiign/s-culturology/app.tsx": [
    "9048",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "37729"
  ],
  "./_deziiign/s-pro/app": [
    "45622",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "18651"
  ],
  "./_deziiign/kiiids/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "43782",
    9,
    "33355"
  ],
  "./_deziiign/s-biology/app.tsx": [
    "72594",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "77743"
  ],
  "./_deziiign/books/pages/tag/index.ts": [
    "17800",
    9,
    "13908",
    "21655",
    "21565",
    "59761"
  ],
  "./_deziiign/continuumsite/img/image_744.png": [
    "46966",
    1,
    "57627"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader/index": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/foodmediiia/app": [
    "86805",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "59126"
  ],
  "./_deziiign/s-culturology/routesList.tsx": [
    "49467",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "76872"
  ],
  "./_competition/pages/CompetitionResultsPage/index.tsx": [
    "4283",
    9,
    "22056",
    "4680"
  ],
  "./_deziiign/booksgallllery/routesList.tsx": [
    "14518",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "98363"
  ],
  "./_deziiign/lab/app.tsx": [
    "14678",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "44571"
  ],
  "./_deziiign/s-management/app": [
    "46822",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "46507"
  ],
  "./_deziiign/books/pages/sections/ps-buttons.tsx": [
    "94539",
    9,
    "48056"
  ],
  "./_deziiign/artmediiia/routesList": [
    "6743",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "88156"
  ],
  "./_deziiign/adcrdafesnet/const/CGRaveCompetitions": [
    "68",
    9,
    "36069"
  ],
  "./_deziiign/booksgallllery/app.tsx": [
    "76643",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "66688"
  ],
  "./_deziiign/pro/routesList.tsx": [
    "16598",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "46706"
  ],
  "./_deziiign/main/pages/eduTagAdmin/EduTagAdminPage": [
    "97728",
    9,
    "27769"
  ],
  "./_deziiign/main/routesList.tsx": [
    "67087",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "47108"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/styles.ts": [
    "1094",
    9,
    "1979",
    "64171"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/index": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/main/pages/projectDeziign/projectDeziign.tsx": [
    "68537",
    9,
    "19955",
    "61186"
  ],
  "./_deziiign/cgrave/pages/CgRaveNomineesPage": [
    "11278",
    9,
    "8739"
  ],
  "./_deziiign/greenaward/styles.tsx": [
    "52890",
    9,
    "32455"
  ],
  "./_geograffee/academy/routesList": [
    "28768",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "71769"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/FloatingPager": [
    "85524",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/types.ts": [
    "94393",
    9
  ],
  "./_deziiign/hsecreativehub/app.tsx": [
    "44527",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "95620"
  ],
  "./_deziiign/brnd/app.tsx": [
    "8109",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "23902"
  ],
  "./_deziiign/books/core/components/bookCard/bookCardTools.tsx": [
    "19117",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/const/hseSpaceCompetitionContexts": [
    "62690",
    9
  ],
  "./_deziiign/continuumsite/components/ContinuumPage.tsx": [
    "43455",
    9,
    "54452"
  ],
  "./_deziiign/s-jurisprudence/app": [
    "87039",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64605"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-longread.tsx": [
    "55855",
    9,
    "20004"
  ],
  "./_geograffee/places/pages/tagPlaces/TagPlacesPage.tsx": [
    "87819",
    9,
    "14488"
  ],
  "./_competition/pages/JuryPage/styles": [
    "80070",
    9
  ],
  "./_geograffee/dafes/app.tsx": [
    "76242",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "37071"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/styles.ts": [
    "18626",
    9,
    "59871"
  ],
  "./_competition/routesList.tsx": [
    "1875",
    9,
    "78074",
    "56496"
  ],
  "./_deziiign/s-computer-science-and-engineering/app.tsx": [
    "24643",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "10720"
  ],
  "./_deziiign/main/pages/MainTagAdminPage/section/Platforms": [
    "59628",
    9
  ],
  "./_deziiign/main/pages/MainTagAdminPage/components/Layout.tsx": [
    "56925",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/index.tsx": [
    "67884",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "11325"
  ],
  "./_deziiign/hsedesign/components/IndexTitle.tsx": [
    "91797",
    9
  ],
  "./_deziiign/game/app.tsx": [
    "86185",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "49170"
  ],
  "./_deziiign/hsespace/components/IndexTitle": [
    "47749",
    9,
    "79686"
  ],
  "./_deziiign/naturemediiia/routesList.tsx": [
    "93869",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97758"
  ],
  "./_deziiign/s-physics/app.tsx": [
    "76764",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "89997"
  ],
  "./_deziiign/onlines/pages/readymag/images/bgReadymag.jpg": [
    "32490",
    1,
    "77559"
  ],
  "./_deziiign/onlines/pages/readymag/english/ReadymagPage.tsx": [
    "43812",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "42722",
    "67269"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionWinnerName": [
    "20936",
    9
  ],
  "./_deziiign/kiiids/routesList.tsx": [
    "85885",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "81038"
  ],
  "./_competition/pages/CreateCompetitionPage/sections/ContextsSections/ContextsSection.tsx": [
    "84390",
    9
  ],
  "./_deziiign/hseanimation/app": [
    "36769",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "25562"
  ],
  "./_competition/pages/CreateCompetitionPage/Components/ShortListProjects/components/CompetitionModalTabs.tsx": [
    "79982",
    9
  ],
  "./_deziiign/damuseum/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "41914",
    9,
    "64647"
  ],
  "./_deziiign/transfermediiia/app": [
    "56774",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "70987"
  ],
  "./_deziiign/hsedesign/pages/TeamEmployeesAdmin/TeamsAdminPage.tsx": [
    "53649",
    9,
    "17642"
  ],
  "./_deziiign/s-philosophy/routesList.tsx": [
    "89821",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "8782"
  ],
  "./_deziiign/books/pages/BookEdit/BookEdit": [
    "72536",
    9
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/apps/blender.svg": [
    "85533",
    1,
    "97038"
  ],
  "./_deziiign/mediiia/routesList": [
    "24864",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "45497"
  ],
  "./_deziiign/s-sociology/routesList.tsx": [
    "82256",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "26089"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/TLandContentEditField": [
    "96241",
    9,
    "80298"
  ],
  "./_deziiign/books/core/components/shareButton": [
    "83831",
    9,
    "5436"
  ],
  "./_deziiign/onlines/pages/readymag/images/icons/mob/stars/star2.svg": [
    "57359",
    1,
    "54532"
  ],
  "./_deziiign/profmediiia/app": [
    "18186",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "51031"
  ],
  "./_deziiign/hsespacefilm/app": [
    "32499",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "38256"
  ],
  "./_deziiign/urbanmediiia/routesList": [
    "31300",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "58533"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/LibBrandingPage": [
    "14885",
    9,
    "6153",
    "1979",
    "13918",
    "63342",
    "58566"
  ],
  "./_deziiign/main/pages/moderHseView": [
    "20217",
    9,
    "99272",
    "73602"
  ],
  "./_deziiign/hsespacecreative/routesList.tsx": [
    "9137",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "27402"
  ],
  "./_deziiign/main/pages/moderView": [
    "15597",
    9,
    "51382",
    "70494"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/styles": [
    "21768",
    9,
    "89105"
  ],
  "./_deziiign/onlines/pages/readymag/library/LibBrandingPage/styles.ts": [
    "21768",
    9,
    "89105"
  ],
  "./_deziiign/damuseum/components/IndexTitle": [
    "42702",
    9,
    "52483"
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/": [
    "67884",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "11325"
  ],
  "./_deziiign/creativemediiia/app.tsx": [
    "38719",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "86621"
  ],
  "./_competition/pages/CreateCompetitionPage/CompetitionJury/CompetitionEditPlus": [
    "89004",
    9,
    "52701"
  ],
  "./_competition/pages/CompetitionResultsPage/CompetitionResultsPage.tsx": [
    "10235",
    9,
    "22056"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/BookImageContainer": [
    "29312",
    9
  ],
  "./_competition/pages/AllCompetitionsPage/styles.css": [
    "30922",
    9
  ],
  "./_deziiign/onlines/app.tsx": [
    "29095",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "13836"
  ],
  "./_deziiign/main/pages/eduTagAdmin/": [
    "25672",
    9,
    "27769",
    "32049"
  ],
  "./_deziiign/awards/utils/index": [
    "97022",
    9,
    "7539"
  ],
  "./_deziiign/kiiids/components/IndexTitle.tsx": [
    "58818",
    9,
    "53023"
  ],
  "./_competition/components/CompetitionFormStart.tsx": [
    "53915",
    9,
    "80328"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/resultitem": [
    "1746",
    9
  ],
  "./_deziiign/hsedesign/pages/EmployeesContext/EmployeesContext.tsx": [
    "51106",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "6879"
  ],
  "./_deziiign/s-economy/app.tsx": [
    "30587",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "69032"
  ],
  "./_deziiign/onlines/pages/readymag/images/EduTrack/DesktopReadymag.svg": [
    "11811",
    1,
    "51200"
  ],
  "./_deziiign/books/pages/BookEdit/BookChaptersEdit/styles.ts": [
    "63011",
    9
  ],
  "./_deziiign/main/app.tsx": [
    "71236",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "47108",
    "20069"
  ],
  "./_competition/const.ts": [
    "19408",
    9
  ],
  "./_deziiign/books/core/components/error-frames/book-edit-frames": [
    "88358",
    9
  ],
  "./_competition/pages/CreateCompetitionPage/": [
    "40565",
    9,
    "23126"
  ],
  "./_deziiign/main/pages/manageTag/contentEditFields/OptionContentEditField": [
    "70009",
    9,
    "30818"
  ],
  "./_deziiign/s-jurisprudence/routesList.tsx": [
    "35639",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "85500"
  ],
  "./_deziiign/s-music/routesList.tsx": [
    "10621",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "31790"
  ],
  "./_geograffee/main/routesList": [
    "29087",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "18900"
  ],
  "./_deziiign/s-arthistory/routesList": [
    "7121",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "87306"
  ],
  "./_deziiign/books/core/components/error-frames/book-edit-frames.tsx": [
    "88358",
    9
  ],
  "./_deziiign/awards/utils": [
    "97022",
    9,
    "7539"
  ],
  "./_competition/pages/AllCompetitionsPage/CompetitionCard.tsx": [
    "76742",
    9
  ],
  "./_deziiign/books/pages/BookListView/BookListView.tsx": [
    "85406",
    9,
    "13908",
    "21655",
    "21565",
    "5357",
    "96979"
  ],
  "./_deziiign/main/pages/moderView/ProjectTilesMapDeziiign.tsx": [
    "16148",
    9,
    "44821"
  ],
  "./_deziiign/damuseum/components/IndexTitle.tsx": [
    "42702",
    9,
    "52483"
  ],
  "./_deziiign/hsecolors/styles": [
    "9186",
    9,
    "86719"
  ],
  "./_deziiign/hsehh/styles": [
    "80446",
    9,
    "78803"
  ],
  "./_deziiign/damuseum/styles": [
    "32402",
    9,
    "67110"
  ],
  "./_deziiign/main/pages/moderHseView/moderHseView": [
    "53627",
    9,
    "99272"
  ],
  "./_deziiign/dvadesign/components/DvaDesignHeader": [
    "81459",
    9,
    "25872"
  ],
  "./_deziiign/main/pages/manageTag/ManageTagEdit.tsx": [
    "441",
    9,
    "70530"
  ],
  "./_deziiign/fashionmediiia/routesList": [
    "77396",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "7477"
  ],
  "./_deziiign/onlines/pages/readymag/video/styles": [
    "48516",
    9,
    "73637"
  ],
  "./_deziiign/musicmediiia/app.tsx": [
    "62630",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "58923"
  ],
  "./_deziiign/hsecolors/styles.tsx": [
    "9186",
    9,
    "86719"
  ],
  "./_deziiign/superpuper/routesList": [
    "76673",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "23130"
  ],
  "./_competition/pages/JuryPage": [
    "5122",
    9,
    "91967"
  ],
  "./_deziiign/s-architect/routesList.tsx": [
    "52833",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "74394"
  ],
  "./_deziiign/cgrave/routesList.tsx": [
    "7524",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "54821"
  ],
  "./_deziiign/books/core/components/datePickerRange/styles.ts": [
    "63545",
    9,
    "82850"
  ],
  "./_deziiign/s-psychology/routesList.tsx": [
    "81139",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "25680"
  ],
  "./_competition/pages/ProjectsPage": [
    "31708",
    9,
    "99309"
  ],
  "./_deziiign/eventmediiia/app.tsx": [
    "98329",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "5890"
  ],
  "./_deziiign/hseanimation/app.tsx": [
    "36769",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "25562"
  ],
  "./_deziiign/hseanimation/routesList": [
    "27072",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "55417"
  ],
  "./_deziiign/main/pages/tagAdmin/TagAdminPage": [
    "44676",
    9,
    "645"
  ],
  "./_deziiign/lmshsecreative/app": [
    "59520",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "64665"
  ],
  "./_deziiign/s-philology/routesList.tsx": [
    "22217",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "1490"
  ],
  "./_deziiign/aimediiia/app": [
    "49867",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "31576"
  ],
  "./_deziiign/damuseum/pages/EmployeesContext/": [
    "4817",
    9,
    "50323",
    "15969",
    "9452",
    "66673",
    "49674"
  ],
  "./_deziiign/books/pages/BookEdit/components/CustomInput.tsx": [
    "40837",
    9,
    "99142"
  ],
  "./_deziiign/s-culturology/app": [
    "9048",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "37729"
  ],
  "./_deziiign/lmshsecreative/routesList": [
    "83811",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "91424"
  ],
  "./_deziiign/awards/pages/TeamEmployeesAdmin/TeamsAdminPage": [
    "56581",
    9,
    "16646"
  ],
  "./_geograffee/places/pages/tagPlaces/components/map/map.tsx": [
    "72684",
    9,
    "6602",
    "96678",
    "52477"
  ],
  "./_competition/pages/AllOpenCalls": [
    "62910",
    9,
    "2003"
  ],
  "./_deziiign/eventmediiia/routesList.tsx": [
    "4152",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "79073"
  ],
  "./_competition/pages/EmptyPage.tsx": [
    "90798",
    9,
    "81251"
  ],
  "./_deziiign/lmshse/app.tsx": [
    "59755",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "7512"
  ],
  "./_deziiign/main/pages/MainTagAdminPage": [
    "53920",
    9,
    "8985"
  ],
  "./_deziiign/main/pages/projectDeziign/sections/ps-authorDeziign": [
    "13598",
    9,
    "72339"
  ],
  "./_deziiign/hsedesign/pages/EmployeesModerContext/EmployeesModerContext.tsx": [
    "95636",
    9,
    "35499",
    "28821"
  ],
  "./_deziiign/books/core/components/booksSearchBar/style.ts": [
    "17998",
    9,
    "56067"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/assets/prev.svg": [
    "89819",
    1,
    "59528"
  ],
  "./_deziiign/school/utils": [
    "89716",
    9,
    "99509"
  ],
  "./_deziiign/dvadesign/app.tsx": [
    "31062",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "83889",
    "86843"
  ],
  "./_deziiign/main/pages/eduTagAdmin": [
    "25672",
    9,
    "27769",
    "32049"
  ],
  "./_deziiign/onlines/pages/readymag/OpenDayPage/OpenDay.tsx": [
    "69568",
    9,
    "6153",
    "1979",
    "64171",
    "93081"
  ],
  "./_deziiign/books/core/hook/api/useBook.ts": [
    "97393",
    9,
    "75882"
  ],
  "./_deziiign/books/core/components/chaptersNavigation/floatingPager/styles.ts": [
    "73222",
    9
  ],
  "./_competition/pages/SeasonEdit/SeasonEditPage.tsx": [
    "94292",
    9,
    "78037"
  ],
  "./_deziiign/urbanmediiia/routesList.tsx": [
    "31300",
    9,
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "58533"
  ],
  "./_deziiign/hsedesign/utils/": [
    "46106",
    9
  ],
  "./_deziiign/fashion/app.tsx": [
    "979",
    9,
    "83762",
    "15969",
    "35974",
    "24092",
    "61971",
    "92444",
    "24364",
    "78074",
    "97775",
    "92287",
    "71237",
    "71856"
  ],
  "./_deziiign/books/core/components/tooltips/index": [
    "40356",
    9
  ]
};
function webpackAsyncContext(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 64979;
module.exports = webpackAsyncContext;
